import React, { useRef, useState, useEffect, use } from 'react';
import useDeviceInfo from "../hooks/useDeviceInfo"; // adjust path as needed

import Ribbon from './Ribbon';
import RibbonTabs from './RibbonTabs';
import ResponsiveInput from "./ResponsiveInput";
import jsPDF from 'jspdf';



import './BracketSpacer.css';
import file_save_img from '../assets/material_icons/file_save.svg';
import Spinner from './Spinner';


import logo_V_img from '../assets/logos/verticallogo.png';
import logo_H_img from '../assets/logos/top logo.png';
import logo_H_black_img from '../assets/logos/horisontal_logo.png';


import picture_as_pdf_img from '../assets/material_icons/picture_as_pdf.svg';
import arrow_forward_img from '../assets/material_icons/arrow_forward.svg';
import arrow_back_img from '../assets/material_icons/arrow_back.svg';
import add_img from '../assets/material_icons/add.svg';
import table_img from '../assets/material_icons/table.svg';
import mop_img from '../assets/material_icons/mop.svg';
import logo_img from '../assets/logos/horisontal_logo.png';
import reset_image_img from '../assets/material_icons/reset_image.svg';
import solar_power_img from '../assets/material_icons/solar_power.svg';

import DynamicList from './DynamicList';

const PanelSelector = ({setPanelId,panelId,setPanelName, panelName, setSubHeight, subHeight,setSubWidth,subWidth, setMountingCentre, mountingCentre,setPanelWeight, deviceType}) => {
    const panelData = [
        { id: 0, name: 'Select (Optional)', width: subWidth, height:  subHeight, mountingCentre: mountingCentre, panelWeight: 23 },
      { id: 1, name: 'AE Mono 460W Half Cell Mono Facial', width:  1902, height: 1133, mountingCentre: 1090, panelWeight: 23.5 },
      { id: 2, name: 'Trinasolar 420w,425W,430W Mono P/N-Type', width: 1762, height: 1134, mountingCentre: 1100, panelWeight: 21.8 },
      { id: 3, name: 'Canadian Solar 144 cell 550W SHP MONO PERC Module HiKu', width: 2278, height: 1134, mountingCentre: 1400, panelWeight: 27.6 },
      { id: 4, name: 'Aiko Comet 2N 625W ', width: 2323, height: 1134, mountingCentre: 1100, panelWeight: 27.7 },
      { id: 5, name: 'JA Solar 585W JAM72S30  Mono P/N-Type', width: 2333, height: 1134, mountingCentre: 1400 ,panelWeight: 28 },



    ];



    const handleSelect = (e) => {
      const selectedId = parseInt(e.target.value);
      const selectedPanel = panelData.find(panel => panel.id === selectedId);
      if (selectedPanel) {
        setPanelName(selectedPanel.name);
        setPanelId(selectedPanel.id);
        setSubHeight(selectedPanel.height);
        setSubWidth(selectedPanel.width);
        setMountingCentre(selectedPanel.mountingCentre);
        setPanelWeight(selectedPanel.panelWeight);
      }
    };

    return (
      <div  style={{width: '100%', padding: '1%', display: 'flex', maxWidth:'650px',flexDirection:(deviceType==='phone' )? 'column': 'row', alignItems: 'flex-start',margin:'auto', justifyContent:(deviceType==='phone' )? '' : 'space-between'}}>
        <label className="responsive-input-label " style={{fontSize: '16px'}}>Select Existing - Optional</label>
        <select
          value={panelId}
          onChange={handleSelect}
          className="border rounded p-2"
          style={{width: '100%', padding: '1%', maxWidth:(deviceType==='phone' )? '200px': '400px'}}
        >
          {panelData.map(panel => (
            <option key={panel.id} value={panel.id}>
              {panel.name}
            </option>
          ))}
        </select>

      </div>
    );
  };


  const PlaceSelector = ({setPlaceId,placeId,setPlaceName, placeName, windSpeed,setWindSpeed, deviceType}) => {
    const panelData = [
    { id: 0, name: 'Please Select', windSpeed: windSpeed },
      { id: 1, name: 'Cape Town', windSpeed: 40 },
        { id: 2, name: 'Port Elizabeth', windSpeed: 37 },
        { id: 3, name: 'East London', windSpeed: 35 },
        { id: 4, name: 'Durban', windSpeed: 32 },
        { id: 5, name: 'Johannesburg', windSpeed: 30 },
        { id: 6, name: 'Pretoria', windSpeed: 30 },
        { id: 7, name: 'Bloemfontein', windSpeed: 31 },
        { id: 8, name: 'Kimberley', windSpeed: 32 },
        { id: 9, name: 'Polokwane', windSpeed: 29 },
        { id: 10, name: 'Nelspruit', windSpeed: 28 },
        { id: 11, name: 'Upington', windSpeed: 32 },
        { id: 12, name: 'George', windSpeed: 35 },
        { id: 13, name: 'Richards Bay', windSpeed: 35 },
        { id: 14, name: 'Beafort West', windSpeed: 36 },



    ];



    const handleSelect = (e) => {
      const selectedId = parseInt(e.target.value);
      const selectedPanel = panelData.find(panel => panel.id === selectedId);
      if (selectedPanel) {
        setPlaceName(selectedPanel.name);
        setPlaceId(selectedPanel.id);
        setWindSpeed(selectedPanel.windSpeed);

      }
    };

    return (
      <div  style={{width: '100%', padding: '1%', display: 'flex', maxWidth:'650px',flexDirection:(deviceType==='phone' )? 'column': 'row', alignItems: 'flex-start',margin:'auto', justifyContent:(deviceType==='phone' )? '' : 'space-between'}}>
                <label className="responsive-input-label " style={{fontSize: '16px'}}>Select a place: Optional</label>
        <select
          value={placeId}
          onChange={handleSelect}
          className="border rounded p-2"
          style={{width: '100%', padding: '1%',  maxWidth:(deviceType==='phone' )? '200px': '400px'}}
        >
          {panelData.map(panel => (
            <option key={panel.id} value={panel.id}>
              {panel.name }
            </option>
          ))}
        </select>

      </div>
    );
  };

  const CatSelector = ({setCategoryId,categoryId,setCategoryName, categoryName, catCoeficient,setCatCoeficient, deviceType}) => {
    const panelData = [
    { id: 0, name: 'Please Select', catCoeficient: catCoeficient },
      { id: 1, name: `I - Open terrain with few obstructions\n(e.g., coastal, flat rural areas)`, catCoeficient: 0.3 },
      { id: 2, name: `II - Suburban areas with low-rise \nbuildings and scattered trees`, catCoeficient: 0.5  },
        { id: 3, name: `III - Urban areas with numerous \nclosely spaced buildings`, catCoeficient: 0.7  },
        { id: 4, name: `IV - Densely built city centers \nwith high-rise buildings`, catCoeficient: 0.8  },


    ];



    const handleSelect = (e) => {
      const selectedId = parseInt(e.target.value);
      const selectedPanel = panelData.find(panel => panel.id === selectedId);
      if (selectedPanel) {
        setCategoryName(selectedPanel.name);
        setCategoryId(selectedPanel.id);
        setCatCoeficient(selectedPanel.catCoeficient);

      }
    };

    return (
      <div  style={{width: '100%', padding: '1%', display: 'flex', maxWidth:'650px',flexDirection:(deviceType==='phone' )? 'column': 'row', alignItems: 'flex-start',margin:'auto', justifyContent:(deviceType==='phone' )? '' : 'space-between'}}>
                        <label className="responsive-input-label " style={{fontSize: '16px'}}>Terain Category</label>
        <select
          value={categoryId}
          onChange={handleSelect}
          className="border rounded p-2"
          style={{width: '100%', padding: '1%',  maxWidth:(deviceType==='phone' )? '200px': '400px'}}
        >
          {panelData.map(panel => (
            <option key={panel.id} value={panel.id}>
              {(panel.id===0)? panel.name : "Category: " + panel.id + " : " + panel.name }
            </option>
          ))}
        </select>

      </div>
    );
  };


  const RoofTypeSelector = ({setBracketType, bracketType, bracketTypeId, setBracketTypeId, deviceType}) => {
    const bracketData = [
     { id: 0, name: 'Please Select',},
      { id: 1, name: 'IBR',},
      { id: 2, name: 'Corrugated',},
      { id: 3, name: 'KlipOn',},
    ];

    const handleSelect = (e) => {
      const selectedId = parseInt(e.target.value);
      const selectedType = bracketData.find(btype => btype.id === selectedId);
      if (selectedType) {
        setBracketType(selectedType.name);
        setBracketTypeId(selectedType.id);
      }
    };

    return (
      <div className="p-4 space-y-4">
        <select
          value={bracketTypeId}
          onChange={handleSelect}
          className="border rounded p-2"
        >
          {bracketData.map(btype => (
            <option key={btype.id} value={btype.id}>
              {btype.name}
            </option>
          ))}
        </select>


      </div>
    );
  };


const Modal = ({ open, title, content, imageUrl, onClose }) => {
    if (!open) return null;
    return (
        <div
            style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            }}
        >
            <div
            style={{
                background: "white",
                padding: "20px",
                borderRadius: "4px",
                width: "300px",
                textAlign: "center",
            }}
            >
            <h2>{title}</h2>
            <p>{content}</p>
            {imageUrl && (
                <img src={imageUrl} alt={title} style={{ maxWidth: "100%" }} />
            )}
            <button style={{ marginTop: "10px" }} onClick={onClose}>Close</button>
            </div>
        </div>
        );
    };

const PdfModal = ({ open, title, content, imageUrl, onClose, setPDFname, pdfName, setShowExportModal,setTempValue,tempValue, noOfRoofs }) => {
        if (!open) return null;
        return (
            <div
                style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                }}
            >
                <div
                style={{
                    background: "white",
                    padding: "20px",
                    borderRadius: "4px",
                    width: "300px",
                    textAlign: "center",
                }}
                >
                    <h2>Export PDF</h2>
                    <p>Please add name for your layout</p>



                    <input
                        label="Layout Title:"
                        value={pdfName}
                        onChange={(e) => setPDFname(e.target.value) || ""}
                        onClick={() => {
                            setTempValue(pdfName);
                            setPDFname("");
                        }}
                        onBlur={() =>
                            setPDFname(pdfName === "" ? tempValue :  pdfName)
                        }
                        style={{
                            flexDirection: 'row',
                            alignSelf: 'flex-start',
                            textAlign: 'left',
                            margin: '0px',
                            padding: "0px",
                            color: "var(--secondary-color)",
                            fontSize: "14px",
                            fontWeight: "700",
                            fontFamily: "'Open Sans', sans-serif",
                        }}
                    />

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                        <button style={{ marginTop: "10px", color: "white", backgroundColor: "var(--warning-color)", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                        onClick={() => {
                            setPDFname("Roof: " + (noOfRoofs+1));
                            setShowExportModal(false);
                            }}
                            >Cancel</button>
                        <button style={{ marginTop: "10px", color: "white", backgroundColor: "var(--primary-color)", border: "none", padding: "5px 10px", borderRadius: "4px" }}
                            onClick={onClose}>Generate PDF</button>
                    </div>
                </div>
            </div>
            );
        };

function getInterpolatedCoef(value, coefData, coefKey) {
    if (!Array.isArray(coefData) || coefData.length === 0 || !coefKey) return null;

    const sorted = [...coefData].sort((a, b) => a.value - b.value);

    if (value <= sorted[0].value) return sorted[0][coefKey];
    if (value >= sorted[sorted.length - 1].value) return sorted[sorted.length - 1][coefKey];

    for (let i = 0; i < sorted.length - 1; i++) {
        const curr = sorted[i];
        const next = sorted[i + 1];

        if (value >= curr.value && value <= next.value) {
        const ratio = (value - curr.value) / (next.value - curr.value);
        return curr[coefKey] + ratio * (next[coefKey] - curr[coefKey]);
        }
    }

    return null;
    }





const BracketSpacer = () => {

    const { deviceType } = useDeviceInfo(); // returns "phone", "tablet", or "desktop"
    const canvasRef = useRef(null);

    const [BOQData,   setBOQData] =  useState([]);
    const [coordinates,   setCoordinates] =  useState([]);
    const [yCoordinate,   setYCoordinate] =  useState([]);

    // Updated main rectangle width to 1500px (default)
    const [mainWidth, setMainWidth] = useState(0);
    const [mainHeight, setMainHeight] = useState(0);
    const [subWidth, setSubWidth] = useState(2000);
    const [subHeight, setSubHeight] = useState(1000);
    const [columnWidth, setColumnWidth] = useState(2);
    //const [internalSpacing, setInternalSpacing] = useState(34);
    const [internalVerticalSpacing, setInternalVerticalSpacing] = useState(17);
    const [internalHorizontalSpacing, setInternalHorizontalSpacing] = useState(0);
    const [spacingBetweenColumns, setSpacingBetweenColumns] = useState(300);
    const [spacingFromTopBottom, setSpacingFromTopBottom] = useState(300);
    const [spacingFromSide, setSpacingFromSide] = useState(300);
    const [mountingCentre, setMountingCentre] = useState(1400);
    const [isExporting, setIsExporting] = useState(false);
    const [showTC, setShowTC] = useState(false);
    const [tempValue, setTempValue] = useState(0);
    const [showRibbonContent, setShowRibbonContent] = useState(true);

    // Layout Params
    const [paramsNoRows, setParamsNoRows] = useState(0);
    const [paramsNoColumns, setParamsNoColumns] = useState(0);
    const [paramsNoPanels, setParamsNoPanels] = useState(0);
    const [paramsNoBrackets, setParamsNoBrackets] = useState(0);


    const [mostLeft, setMostLeft] = useState(0);
    const [mostTop, setMostTop] = useState(0);

    const [mostLeftPdf, setMostLeftPdf] = useState(0);
    const [mostTopPdf, setMostTopPdf] = useState(0);

    const [maxPanels, setMaxPanels] = useState(1000);



    // per Roof
    const [noBrackets, setNoBrackets] = useState(0);
    const [noPanels, setNoPanels] = useState(0);
    const [pdfName, setPDFName] = useState("Roof: 1");
    const [showExportModal, setShowExportModal] = useState(false);
    const [noEarthClips, setNoEarthClips] = useState(0);
    const [noAntiTamperClips, setNoAntiTamperClips] = useState(0);
    const [noEndSpacers, setNoEndSpacers] = useState(0);
    const [noOfRoofs, setNoOfRoofs] = useState(0);
    const [maxPanelsRoof, setMaxPanelsRoof] = useState(1000);

    //All Roofs
    const [totalPanels, setTotalPanels] =useState(0) ;
    const [totalBrackets, setTotalBrackets]  = useState(0) ;
    const [totalEarthClips, setTotalEarthClips]  = useState(0) ;
    const [totalEndSpacers, setTotalEndSpacers]  = useState(0) ;
    const [totalAntiTamperClips, setTotalAntiTamperClips]  = useState(0) ;

    //
    const [showTotals, setShowTotals] = useState(false);
    const [currentUnsaved, setCurrentUnsaved] = useState(true);
    const [showCoordsModal, setShowCoordsModal] = useState(false);

    //BOQ
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [modalName, setModalName] = useState('');


    // Brackets
    const [noBracketsIBR, setNoBracketsIBR] = useState(0);
    const [noBracketsCor, setNoBracketsCor] = useState(0);
    const [noBracketsKlik, setNoBracketsKlik] = useState(0);
    const [bracketType, setBracketType] = useState('Please Select');
    const [bracketTypeId, setBracketTypeId] = useState(0);


    // PanelData
    const [panelName, setPanelName] = useState('Select (Optional)');
    const [panelId, setPanelId] = useState(0);

    // wind Load

    const angleCoefs =[
        {value: 0, coefUplift: 1.1, coefShear: 0.6},
        {value: 5,  coefUplift: 1.15, coefShear: 0.65},
        {value: 10,  coefUplift: 1.2, coefShear: 0.7},
        {value: 15,  coefUplift: 1.3, coefShear: 0.8},
        {value: 20,  coefUplift: 1.4, coefShear: 0.85},
        {value: 25,  coefUplift: 1.5, coefShear: 0.9},
        {value: 30,  coefUplift: 1.6, coefShear: 0.95},
        {value: 35,  coefUplift: 1.7, coefShear: 1},
        {value: 40,  coefUplift: 1., coefShear: 1.05},
        {value: 45,  coefUplift: 1.,   coefShear: 1.1},
    ]
    const terrainCoefs =[
        {value: 1, coefExposure: 1.2, coefTopography: 1.3},
        {value: 2, coefExposure: 1, coefTopography: 1.2},
        {value: 3, coefExposure: 0.85, coefTopography: 1.1},
        {value: 4, coefExposure: 0.7, coefTopography: 1},
    ]



    const [placeName, setPlaceName] = useState('Select (Optional)');
    const [windSpeed, setWindSpeed] = useState(40);
    const [placeId, setPlaceId] = useState(0);

    const [categoryName, setCategoryName] = useState('Please Select');
    const [categoryId, setCategoryId] = useState(0);
    const [catCoeficient, setCatCoeficient] = useState(1);
    const [combinedCoeficient, setCombinedCoefficient] = useState(1);
    const [airDensity, setAirDensity] = useState(1.225);
    const [panelArea, setPanelArea] = useState(0);

    const [windLoad, setWindLoad] = useState(0);

    const [terrainCategory, setTerrainCategory] = useState(1);
    const [roofAngle, setRoofAngle] = useState(15);

    const [roofAngleCoef, setRoofAngleCoef] = useState(1);
    const [upliftCoef, setUpliftCoef] = useState(1);
    const [terrainCategoryCoef, setTerrainCategoryCoef] = useState(1);
    const [terrainCategoryCoefTop, setTerrainCategoryCoefTop] = useState(1);
    const [terrainCategoryCoefUplift, setTerrainCategoryCoefUplift] = useState(1);
    const [terrainCategoryCoefUpliftTop, setTerrainCategoryCoefUpliftTop] = useState(1);

    const [exposureCoef, setExposureCoef] = useState(1);
    const [topographyCoef, setTopographyCoef] = useState(1);
    const [designWindSpeed, setDesignWindSpeed] = useState(0);
    const [designWindPressure, setDesignWindPressure] = useState(0);
    const [upliftForce, setUpliftForce] = useState(0);
    const [designShearForce, setDesignShearForce] = useState(0);
    const [panelWeight, setPanelWeight] = useState(23);
    const [mountingWeight, setMountingWeight] = useState(0.6);
    const [shearForce, setShearForce] = useState(0);
    const [shearCoef, setShearCoef] = useState(1);

    const [ultimateUpliftForce, setUltimateUpliftForce] = useState(0);

    const bracketLoad9_008 = 9.008;
    const bracketLoad11_26 = 11.26;
    const [windLoadSafetyFactor, setWindLoadSafetyFactor] = useState(1.5);
    const [loadIsCompliant, setLoadIsCompliant] = useState('Compliant');
    const [windloadCalcTrigger, setWindloadCalcTrigger] = useState(false);
    const [windloadCoefTrigger, setWindloadCoefTrigger] = useState(false);

    useEffect(() => {
        setTotalPanels(BOQData.reduce((acc, item) => acc + item.noPanels, 0));
        setTotalBrackets(BOQData.reduce((acc, item) => acc + item.noBrackets, 0));
        setTotalEarthClips(BOQData.reduce((acc, item) => acc + item.noEarthClips, 0));
        setTotalEndSpacers(BOQData.reduce((acc, item) => acc + item.noEndSpacers, 0));
        setTotalAntiTamperClips(BOQData.reduce((acc, item) => acc + item.noAntiTamperClips, 0));

        if (BOQData.length > 0) {
            setShowTotals(true);
        }
        else {
            setShowTotals(false);
        }

    }, [BOQData]);

    useEffect(() => {
        setCurrentUnsaved(true);

    }, [mainHeight, mainWidth, subHeight, subWidth, spacingBetweenColumns, spacingFromSide, spacingFromTopBottom, columnWidth, internalHorizontalSpacing, internalVerticalSpacing]);

    useEffect(() => {
        setPDFName('Roof: ' + (noOfRoofs+1));}
    , [noOfRoofs]);

    useEffect(() => {
        setPanelArea(subHeight*subWidth/1000000);
        console.log("Panel Area: ", panelArea);

    }
    , [subHeight,subWidth, windloadCalcTrigger]);

    useEffect(() => {
        setExposureCoef(getInterpolatedCoef(categoryId, terrainCoefs, 'coefExposure'));
        setTopographyCoef(getInterpolatedCoef(categoryId, terrainCoefs, 'coefTopography'));
        console.log("Exposure Coef: ", exposureCoef);
        console.log("Topography Coef: ", topographyCoef);
    }
    , [categoryId,windloadCalcTrigger]);

    useEffect(() => {
        setUpliftCoef(getInterpolatedCoef(roofAngle, angleCoefs, 'coefUplift'));
        setShearCoef(getInterpolatedCoef(roofAngle, angleCoefs, 'coefShear'));
        console.log("Uplift Coef: ", upliftCoef);
        console.log("Shear Coef: ", shearCoef);
        }, [roofAngle, windloadCalcTrigger]);

    useEffect(() => {
        setDesignWindSpeed(windSpeed*exposureCoef*topographyCoef);
        console.log("Design Wind Speed: ", designWindSpeed);
    },[windSpeed, exposureCoef, topographyCoef,windloadCalcTrigger]);

    useEffect(() => {
        setDesignWindPressure(0.5*airDensity*Math.pow(designWindSpeed,2));
        console.log("Design Wind Pressure: ", designWindPressure);
    },[designWindSpeed, airDensity,windloadCalcTrigger]);

    useEffect(() => {
        setUpliftForce(panelArea*designWindPressure*upliftCoef/1000);
        console.log("Uplift Force: ", upliftForce);
    },[panelArea, designWindPressure, upliftCoef,windloadCalcTrigger]);

    useEffect(() => {
        setUltimateUpliftForce(0.9*((panelWeight+mountingWeight)*9.81/1000)+1.3*upliftForce);
        console.log("Ultimate Uplift Force: ", ultimateUpliftForce);
    },[panelWeight, mountingWeight, upliftForce,windloadCalcTrigger]);

    useEffect(() => {
        setShearForce(panelArea*designWindPressure*shearCoef/1000);
        console.log("Shear Force: ", shearForce);
    },[panelArea, designWindPressure, shearCoef,windloadCalcTrigger]);

    useEffect(() => {
        setWindLoadSafetyFactor(bracketLoad11_26/ultimateUpliftForce);
        console.log("Wind Load Safety Factor: ", windLoadSafetyFactor,);
    },[ultimateUpliftForce,windloadCalcTrigger]);

    useEffect(() => {
        if (ultimateUpliftForce < bracketLoad9_008) {
            setLoadIsCompliant('Compliant');
        } else if (ultimateUpliftForce > bracketLoad11_26) {
            setLoadIsCompliant(`Not Compliant, contact Deo Solar for advise.  \nRecommended to install additional mounting per panel`)
        } else {
            setLoadIsCompliant(`Compliant with reduced safety factor of :\n `+ Math.ceil(windLoadSafetyFactor*100)/100)
        }
        console.log("Load is Compliant: ", loadIsCompliant);
    }, [ultimateUpliftForce, windLoadSafetyFactor,windloadCalcTrigger]);


    //  zoom and pan
        const [zoom, setZoom] = useState(0.03);
        const [offset, setOffset] = useState({ x: 0, y: 0 });
        const [drawTrigger, setDrawTrigger] = useState(false);
        const [isPanning, setIsPanning] = useState(false);
        const [lastPan, setLastPan] = useState({ x: 0, y: 0 });
        const [touchDistance, setTouchDistance] = useState(null);

        const clampZoom = (z) => Math.min(Math.max(z, 0.01), 0.1);

    // Tabs and Modal
        const [activeTab, setActiveTab] = useState("main");
        const [modalContent, setModalContent] = useState(null);
        const openModal = (title, content, imageUrl = null) => {
            setModalContent({ title, content, imageUrl });
        };
        const closeModal = () => setModalContent(null);

    //consent
        const [showConsent, setShowConsent] = useState(false);

        useEffect(() => {
            const consentGiven = localStorage.getItem("DS2popiaConsent");
            if (!consentGiven) {
                setShowConsent(true);
            }
        }, []);

        const handleAccept = () => {
        localStorage.setItem("DS2popiaConsent", "true");
        setShowConsent(false);
        };

    // ScreenSize
        const [screenWidth, setScreenWidth] = useState(window.innerWidth);
        const [screenHeight, setScreenHeight] = useState(window.innerHeight);

        useEffect(() => {
            const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
            };
            window.addEventListener("resize", handleResize);
            return () => {
            window.removeEventListener("resize", handleResize);
            };
        }, []);

    // Draw Function
        const draw = () => {

            setCoordinates([]);
            setYCoordinate([]);
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');

            // Clear and set background white
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.fillStyle = 'lightgray';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Apply zoom and pan transformations
            ctx.setTransform(zoom, 0, 0, zoom, offset.x, offset.y);

            const mainX = 3000;
            const mainY = 2000;

            // Draw Drawing border rectangle with fill and a border
            ctx.fillStyle = 'White';
            ctx.fillRect(mainX-3000, mainY-2000, mainWidth+3500, mainHeight+3500);
            ctx.lineWidth = 5;  // You can change the border thickness here if desired.
            ctx.strokeStyle = 'black';
            ctx.strokeRect(mainX-3000, mainY-2000, mainWidth+3500, mainHeight+3500);

            // Draw main rectangle with fill and a border
            const stripeWidth = 20;

            for (let x = mainX; x < mainX + mainWidth; x += stripeWidth * 2) {
                ctx.fillStyle = 'lightgray';
                ctx.fillRect(x, mainY, stripeWidth, mainHeight);
            }

            ctx.lineWidth = 5;
            ctx.strokeStyle = 'black';
            ctx.strokeRect(mainX, mainY, mainWidth, mainHeight);


            const usableWidth = mainWidth - 2 * spacingFromSide; //spacingFromSide //
            const usableHeight = mainHeight - 2 * spacingFromTopBottom; //spacingFromTopBottom //

            const subColumnsPerMainColumn = columnWidth;
            const subColumnWidth =
                subWidth * subColumnsPerMainColumn +
                internalHorizontalSpacing * (subColumnsPerMainColumn - 1);
            const noOfMainColumns = Math.floor(
                (usableWidth + spacingBetweenColumns) / (subColumnWidth + spacingBetweenColumns)
            );

            const widtOfCompletColumns=noOfMainColumns*(subColumnsPerMainColumn*(subWidth + internalHorizontalSpacing)) +spacingBetweenColumns*(noOfMainColumns-1)
            const usableWidthLeft=usableWidth -widtOfCompletColumns - spacingBetweenColumns
            const noOfLastSubColums = Math.floor(usableWidthLeft/(subWidth + internalHorizontalSpacing))


            const subRectanglesPerColumn = Math.floor(
                (usableHeight + internalVerticalSpacing) / (subHeight + internalVerticalSpacing)
            );

            const totalSubHeight =  subRectanglesPerColumn * subHeight + (subRectanglesPerColumn - 1) * internalVerticalSpacing;
            const totalSubWidth = noOfMainColumns * subColumnWidth + (noOfMainColumns - 1) * spacingBetweenColumns;
            let totalSubWithPlusResWaarde = totalSubWidth
            if (noOfLastSubColums > 0) {
                totalSubWithPlusResWaarde =  widtOfCompletColumns+ spacingBetweenColumns+(noOfLastSubColums*(subWidth + internalHorizontalSpacing))
            } else {
                totalSubWithPlusResWaarde = widtOfCompletColumns
            }

            const leftMargin = (mainWidth - totalSubWithPlusResWaarde) / 2; //spacingFromSide //
            const topMargin = (mainHeight - totalSubHeight) / 2; //spacingFromTopBottom //


            const allColumns = (noOfMainColumns * subColumnsPerMainColumn) + noOfLastSubColums

            const maxFittingPanels = (allColumns * subRectanglesPerColumn);





            let subColumnsForMax = Math.floor(maxFittingPanels / (subRectanglesPerColumn));
            let mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
            let panelsInLastSubColumn =subRectanglesPerColumn
            let endSpacersReal =allColumns*4
            let noEarthClipsReal =allColumns*(subRectanglesPerColumn-1)
            let noBracketsReal =allColumns*(subRectanglesPerColumn*2+2)
            let noAntiTampersReal =allColumns*(subRectanglesPerColumn*2+2)
            if (maxPanels <= maxFittingPanels) {
                    subColumnsForMax = Math.floor(maxPanels / (subRectanglesPerColumn));
                    mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
                    panelsInLastSubColumn =maxPanels - subColumnsForMax*subRectanglesPerColumn
                    endSpacersReal =subColumnsForMax *4 + Math.ceil(panelsInLastSubColumn/ subRectanglesPerColumn)*4
                    noEarthClipsReal =subColumnsForMax*(subRectanglesPerColumn-1) + Math.max(0, panelsInLastSubColumn-1)
                    noBracketsReal =subColumnsForMax*(subRectanglesPerColumn*2+2)+ panelsInLastSubColumn*2+2
                    noAntiTampersReal =subColumnsForMax*(subRectanglesPerColumn*2+2)+ panelsInLastSubColumn*2+2
                }



            let panelCounter = 1;

            let bracketCounter = 0;

            ctx.font = '12px Arial';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';


            //Column End
            ctx.beginPath();
            ctx.moveTo(mainX, -1250+mainY);
            ctx.lineTo(mainX+mainWidth, -1250+mainY);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();

            ctx.fillStyle = 'black';
            ctx.font = '180px Arial';
            ctx.fillText('Column End', mainX-1200, -1250+mainY);


            //Column start
            ctx.beginPath();
            ctx.moveTo(mainX, -800+mainY);
            ctx.lineTo(mainX+mainWidth, -800+mainY);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();

            ctx.fillStyle = 'black';
            ctx.font = '180px Arial';
            ctx.fillText('Column Start', mainX-1200, -800+mainY);

            //Bracket Postiion hor
            ctx.beginPath();
            ctx.moveTo(mainX, -200+mainY);
            ctx.lineTo(mainX+mainWidth, -200+mainY);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();

            ctx.fillStyle = 'black';
            ctx.font = '180px Arial';
            ctx.fillText('Bracket Position from B0     ', mainX-1050, -200+mainY);

            //Bracket Postiion Vert
            ctx.beginPath();
            ctx.moveTo(mainX-450, mainY);
            ctx.lineTo(mainX-450, mainY+mainHeight);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.stroke();






            for (let mainCol = 0; mainCol < noOfMainColumns; mainCol++) {
                for (let subCol = 0; subCol < subColumnsPerMainColumn; subCol++) {

                    for (let row = 0; row < subRectanglesPerColumn; row++) {


                        if (panelCounter > maxPanels)

                            break;


                        const x = //top of panel
                            mainX +
                            leftMargin +
                            mainCol * (subColumnWidth + spacingBetweenColumns) +
                            subCol * (subWidth + internalHorizontalSpacing);

                        const y = //left of panel
                            mainY +
                            topMargin +
                            row * (subHeight + internalVerticalSpacing);
;
                        //panel
                        ctx.fillStyle = 'lightgreen';
                        ctx.strokeStyle = 'darkgreen';
                        ctx.fillRect(x, y, subWidth, subHeight);
                        ctx.strokeRect(x, y, subWidth, subHeight);

                        ctx.fillStyle = 'black';
                        ctx.font = '180px Arial';
                        ctx.fillText('Panel ' + panelCounter++, x + subWidth / 2, y + subHeight / 2);



                        //Bracket 1 & 2 HOR
                        const B1 = x + subWidth / 2 - mountingCentre / 2;
                        const B2 = x + subWidth / 2 + mountingCentre / 2;

                        if (mainCol !== 0) {


                            ctx.fillText('|', B1, y);

                            ctx.fillText('B1', B1, -600+mainY);
                            ctx.fillText(B1-mainX-mostLeft, B1, -400+mainY);
                            ctx.fillText('|', B1, -200+mainY);
                            if (panelCounter > maxPanels){
                                ctx.fillText('|', B1, y+subHeight);
                            }

                        }

                        ctx.font = '180px Arial';
                        ctx.fillText('|', B2, y);
                        ctx.fillText('B2', B2, -600+mainY);
                        ctx.fillText(B2-mainX-mostLeft, B2, -400+mainY);
                        ctx.fillText('|', B2, -200+mainY);
                        if (panelCounter > maxPanels){
                                ctx.fillText('|', B2, y+subHeight);
                            }

                        if (mainCol === 0) {
                            //0,0r0
                            if (subCol === 0) {
                                setMostLeft(B1-mainX)

                                ctx.font = '180px Arial';
                                ctx.fillText(  "CS" +(mainCol + 1) + ": " + (B1-x)+ " left of B0. (" +((x-mainX))+ " from side)", x, -1000+mainY);
                                ctx.font = '180px Arial';
                                ctx.fillText('|', x, -800+mainY);


                                if (panelCounter <= 2){
                                ctx.fillText('B|0', B1, y);
                                    } else ctx.fillText('|', B1, y);
                                ctx.fillText('B0', B1, -600+mainY);
                                ctx.fillText("( "+ (B1-mainX)+ " from side) 0", B1, -400+mainY);
                                ctx.fillText('|', B1, -200+mainY);
                                if (panelCounter > maxPanels){
                                    ctx.fillText('|', B1, y+subHeight);
                                }

                                if ( row === 0) {

                                    //start
                                    const newItemCS = {
                                        id: `Column ${mainCol+1} Start From Side`,
                                        x: (x-mainX),
                                    }
                                    setCoordinates(prev => [...prev, newItemCS]);

                                    const newItemCSS = {
                                        id: `Column ${mainCol+1} Start`,
                                        x: (x-mainX-mostLeft),
                                    }
                                    setCoordinates(prev => [...prev, newItemCSS]);


                                    //B1b2
                                    const newItemB1 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B0`,
                                        x: B1-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB1]);

                                    const newItemB2 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                        x: B2-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB2]);


                                    // Bracket 1 & 2 VER ROW1
                                    setMostTop(y- mainY - internalVerticalSpacing / 2)

                                    ctx.font = '180px Arial';
                                    ctx.fillText("( B0: " + Math.round(((y- mainY - internalVerticalSpacing / 2)/10))*10 + " to ridge)  0        --    ", -1000+mainX, y);

                                    const newItemY= {
                                        row: row,
                                        y: y- mainY - internalVerticalSpacing / 2,
                                    }
                                    setYCoordinate(prev => [...prev, newItemY]);

                                    const newItemYS= {
                                        row: row+1,
                                        y: y- mainY - internalVerticalSpacing / 2-mostTop,
                                    }
                                    setYCoordinate(prev => [...prev, newItemYS]);
                                } else {
                                    if (row ===(subRectanglesPerColumn-1)) {
                                        ctx.font = '180px Arial';
                                        ctx.fillText(Math.round(((y- mainY - internalVerticalSpacing / 2-mostTop)/10))*10 + ' to top bracket (B0) --    ', -1000+mainX, y);
                                        const newItemY= {
                                            row: row+1,
                                            y: y- mainY - internalVerticalSpacing / 2-mostTop,
                                        }
                                        setYCoordinate(prev => [...prev, newItemY]);

                                        ctx.font = '180px Arial';
                                        //ctx.fillText(Math.round(((y- mainY - internalVerticalSpacing / 2-mostTop)/10))*10  + ' to top bracket (B0) --    ', -1000+mainX, y+ subHeight + internalVerticalSpacing/2);
                                        const newItemYE= {
                                            row: row+1,
                                            y: y- mainY - internalVerticalSpacing / 2 + subHeight + internalVerticalSpacing/2-mostTop ,
                                        }
                                        setYCoordinate(prev => [...prev, newItemYE]);


                                    } else {
                                            ctx.font = '180px Arial';
                                            ctx.fillText(Math.round(((y- mainY - internalVerticalSpacing / 2-mostTop)/10))*10 + ' to top bracket (B0) --    ', -1000+mainX, y);
                                            const newItemY= {
                                                row: row+1,
                                                y: y- mainY - internalVerticalSpacing / 2-mostTop,
                                            }
                                            setYCoordinate(prev => [...prev, newItemY]);
                                    }
                            }
                         } else {

                            ctx.fillText('|', B1, y);
                            ctx.fillText('B1', B1, -600+mainY);
                            ctx.fillText(B1-mainX-mostLeft, B1, -400+mainY);
                            ctx.fillText('|', B1, -200+mainY);
                            if (panelCounter > maxPanels){
                                    ctx.fillText('|', B1, y+subHeight);
                                }


                                if (subCol === subColumnsPerMainColumn-1) {

                                    if (row === 0) {


                                        const newItemB1 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                            x: B1-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB1]);

                                        const newItemB2 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                            x: B2-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB2]);

                                        const newItemCE = {
                                            id: `Column ${mainCol+1} End`,
                                            x: (x-mainX + subWidth-mostLeft),
                                        }

                                        setCoordinates(prev => [...prev, newItemCE]);

                                    }
                                }  else {
                                if (row === 0) {
                                    const newItemB1 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                        x: B1-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB1]);

                                    const newItemB2 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                        x: B2-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB2]);

                                }

                            }
                        }
                        } else {
                            if (subCol === 0) {
                                ctx.font = '180px Arial';
                                    ctx.fillText('CS' + (mainCol + 1) + ': ' + (x-mainX-mostLeft), x, -1000+mainY);
                                    ctx.font = '180px Arial';
                                    ctx.fillText('|', x, -800+mainY);

                                if (row === 0) {
                                    const newItemCS = {
                                        id: `Column ${mainCol+1} Start`,
                                        x: (x-mainX-mostLeft),
                                    }
                                    setCoordinates(prev => [...prev, newItemCS]);

                                    const newItemB1 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                        x: B1-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB1]);

                                    const newItemB2 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                        x: B2-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB2]);
                                }
                            } else {
                                if (subCol === subColumnsPerMainColumn-1) {
                                    if (row === 0) {


                                        const newItemB1 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                            x: B1-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB1]);

                                        const newItemB2 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                            x: B2-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB2]);

                                        const newItemCE = {
                                            id: `Column ${mainCol+1} End`,
                                            x: (x-mainX + subWidth-mostLeft),
                                        }

                                        setCoordinates(prev => [...prev, newItemCE]);

                                    }
                                } else {
                                if (row === 0) {
                                    const newItemB1 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                        x: B1-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB1]);

                                    const newItemB2 = {
                                        id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                        x: B2-mainX-mostLeft,
                                    }
                                    setCoordinates(prev => [...prev, newItemB2]);

                                }
                            }
                        }



                        }

                        if (row === subRectanglesPerColumn - 1) {
                        ctx.font = '180px Arial';
                        ctx.fillText(Math.round((y- mainY  + subHeight + internalVerticalSpacing / 2-mostTop)/10)*10  + ' to top bracket (B0) --    ', -1000+mainX, y + subHeight);
                        ctx.fillText('|', B1, y + subHeight);
                        ctx.fillText('|', B2, y + subHeight);

                        // if (mainCol === 0) {

                        //     if(subCol === 0) {

                        //     const newItemY= {
                        //         row: row+1,
                        //         y: y- mainY  + subHeight + internalVerticalSpacing / 2-mostTop,
                        //     }

                        //     setYCoordinate(prev => [...prev, newItemY]);

                        //     }
                        // }
                        }



                        if (subCol === subColumnsPerMainColumn - 1) {
                        ctx.font = '180px Arial';
                        ctx.fillText('CE' + (mainCol + 1) + ': ' + (x -mainX + subWidth-mostLeft), x + subWidth, -1450+mainY);
                        ctx.font = '180px Arial';
                        ctx.fillText('|', x + subWidth, -1250+mainY);

                        // if ( row === (subRectanglesPerColumn-1)) {
                        //     const newItemCE = {
                        //         id: `Column ${mainCol+1} End`,
                        //         x: x -mainX + subWidth-mostLeft,
                        //     }
                        //     setCoordinates(prev => [...prev, newItemCE]);
                        // }
                        }

                        ctx.beginPath();
                        ctx.moveTo(B1, y);
                        ctx.lineTo(B1, y + subHeight);
                        ctx.strokeStyle = 'black';
                        ctx.lineWidth = 2;
                        ctx.stroke();
                        ctx.beginPath();
                        ctx.moveTo(B2, y);
                        ctx.lineTo(B2, y + subHeight);
                        ctx.strokeStyle = 'black';
                        ctx.lineWidth = 2;
                        ctx.stroke();

                        bracketCounter += 2;
                        if (panelCounter > maxPanels) {
                            bracketCounter += 2;
                        }
                        if (row === subRectanglesPerColumn-1) {
                            bracketCounter += 2;
                        }
                        setNoBrackets(bracketCounter);
                        setNoPanels(panelCounter-1);



                    }
                }
            }


            /////////////////////////////
            if (noOfLastSubColums > 0) {
                for (let mainCol =  mainColumnsForMax; mainCol <  mainColumnsForMax+1; mainCol++) {
                    for (let subCol = 0; subCol < noOfLastSubColums; subCol++) {
                        for (let row = 0; row < subRectanglesPerColumn; row++) {
                            if (panelCounter > maxPanels)
                                break;


                            const x = //top of panel
                                mainX +
                                leftMargin +
                                // widtOfCompletColumns +spacingBetweenColumns+
                                mainCol * (subColumnWidth + spacingBetweenColumns) +
                                subCol * (subWidth + internalHorizontalSpacing);

                            const y = //left of panel
                                mainY +
                                topMargin +
                                row * (subHeight + internalVerticalSpacing);

                            //panel
                            ctx.fillStyle = 'lightgreen';
                            ctx.strokeStyle = 'darkgreen';
                            ctx.fillRect(x, y, subWidth, subHeight);
                            ctx.strokeRect(x, y, subWidth, subHeight);

                            ctx.fillStyle = 'black';
                            ctx.font = '180px Arial';
                            ctx.fillText('Panel ' + panelCounter++, x + subWidth / 2, y + subHeight / 2);



                            //Bracket 1 & 2 HOR
                            const B1 = x + subWidth / 2 - mountingCentre / 2;
                            const B2 = x + subWidth / 2 + mountingCentre / 2;



                                ctx.fillText('|', B1, y);
                                ctx.fillText('B1', B1, -600+mainY);
                                ctx.fillText(B1-mainX-mostLeft, B1, -400+mainY);
                                ctx.fillText('|', B1, -200+mainY);
                                if (panelCounter > maxPanels){
                                    ctx.fillText('|', B1, y+subHeight);
                                }



                            ctx.font = '180px Arial';
                            ctx.fillText('|', B2, y);
                            ctx.fillText('B2', B2, -600+mainY);
                            ctx.fillText(B2-mainX-mostLeft, B2, -400+mainY);
                            ctx.fillText('|', B2, -200+mainY);
                            if (panelCounter > maxPanels){
                                    ctx.fillText('|', B2, y+subHeight);
                                }

                                if (subCol === 0) {
                                    ctx.font = '180px Arial';
                                        ctx.fillText('CS' + (mainCol + 1) + ': ' + (x-mainX-mostLeft), x, -1000+mainY);
                                        ctx.font = '180px Arial';
                                        ctx.fillText('|', x, -800+mainY);

                                    if (row === 0) {
                                        const newItemCS = {
                                            id: `Column ${mainCol+1} Start`,
                                            x: (x-mainX-mostLeft),
                                        }
                                        setCoordinates(prev => [...prev, newItemCS]);

                                        const newItemB1 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                            x: B1-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB1]);

                                        const newItemB2 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                            x: B2-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB2]);
                                    }
                                } else {
                                    if (subCol === subColumnsPerMainColumn-1) {
                                        if (row === 0) {


                                            const newItemB1 = {
                                                id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                                x: B1-mainX-mostLeft,
                                            }
                                            setCoordinates(prev => [...prev, newItemB1]);

                                            const newItemB2 = {
                                                id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                                x: B2-mainX-mostLeft,
                                            }
                                            setCoordinates(prev => [...prev, newItemB2]);

                                            const newItemCE = {
                                                id: `Column ${mainCol+1} End`,
                                                x: (x-mainX + subWidth-mostLeft),
                                            }

                                            setCoordinates(prev => [...prev, newItemCE]);

                                        }
                                    } else {
                                    if (row === 0) {
                                        const newItemB1 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B1`,
                                            x: B1-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB1]);

                                        const newItemB2 = {
                                            id: `Column ${mainCol+1}. ${subCol+1} B2`,
                                            x: B2-mainX-mostLeft,
                                        }
                                        setCoordinates(prev => [...prev, newItemB2]);

                                    }
                                }
                            }


                            if (row === subRectanglesPerColumn - 1) {
                            ctx.font = '180px Arial';
                          //  ctx.fillText(y- mainY  + subHeight + internalVerticalSpacing / 2-mostTop + ' to top bracket    --    ', -1000+mainX, y + subHeight);
                            ctx.fillText('|', B1, y + subHeight);
                            ctx.fillText('|', B2, y + subHeight);

                            // if (mainCol === 0) {

                            //     if(subCol === 0) {

                            //     const newItemY= {
                            //         row: row+1,
                            //         y: y- mainY  + subHeight + internalVerticalSpacing / 2-mostTop,
                            //     }

                            //     setYCoordinate(prev => [...prev, newItemY]);

                            //     }
                            // }
                            }



                            if (subCol === subColumnsPerMainColumn - 1) {
                            ctx.font = '180px Arial';
                            ctx.fillText('CE' + (mainCol + 1) + ': ' + (x -mainX + subWidth-mostLeft), x + subWidth, -1450+mainY);
                            ctx.font = '180px Arial';
                            ctx.fillText('|', x + subWidth, -1250+mainY);

                            // if ( row === (subRectanglesPerColumn-1)) {
                            //     const newItemCE = {
                            //         id: `Column ${mainCol+1} End`,
                            //         x: x -mainX + subWidth-mostLeft,
                            //     }
                            //     setCoordinates(prev => [...prev, newItemCE]);
                            // }
                            }

                            ctx.beginPath();
                            ctx.moveTo(B1, y);
                            ctx.lineTo(B1, y + subHeight);
                            ctx.strokeStyle = 'black';
                            ctx.lineWidth = 2;
                            ctx.stroke();
                            ctx.beginPath();
                            ctx.moveTo(B2, y);
                            ctx.lineTo(B2, y + subHeight);
                            ctx.strokeStyle = 'black';
                            ctx.lineWidth = 2;
                            ctx.stroke();

                            bracketCounter += 2;
                            if (panelCounter > maxPanels) {
                                bracketCounter += 2;
                            }
                            if (row === subRectanglesPerColumn-1) {
                                bracketCounter += 2;
                            }
                            setNoBrackets(bracketCounter);
                            setNoPanels(panelCounter-1);



                        }
                    }
                }
            }




            //////////////////////////





            setNoAntiTamperClips(noBracketsReal)
            setNoEarthClips(noEarthClipsReal)
            setNoEndSpacers(endSpacersReal)


            if (panelCounter === 0) {
                setParamsNoPanels(0);
            }   else {
                setParamsNoPanels(panelCounter-1);
            }
            if (subRectanglesPerColumn < 0) {
                setParamsNoRows(0);
            } else {
                setParamsNoRows(subRectanglesPerColumn);
            }
            if (noOfMainColumns < 0) {
                setParamsNoColumns(0);
            } else {
                setParamsNoColumns(noOfMainColumns);
            }
            if (bracketCounter < 0) {
                setParamsNoBrackets(0);

            } else {
                setParamsNoBrackets(bracketCounter);

            }

            // ctx.fillText('maxFittingPanels ', 0, 1500);
            // ctx.fillText(maxFittingPanels , 1000, 1500);


            // ctx.fillText('allColumns ', 0, 0);
            // ctx.fillText(allColumns , 1000, 0);

            // ctx.fillText('MainColumns', 0, 300);
            // ctx.fillText(mainColumnsForMax, 1000, 300);

            // ctx.fillText('subColumnsForMax', 0, 600);
            // ctx.fillText(subColumnsForMax, 1000, 600);

            //  ctx.fillText('panelsInLastSubColumn', 0, 900);
            // ctx.fillText(panelsInLastSubColumn, 1000, 900);


            // ctx.fillText('NoEndSpacers', 0, 1200);
            // ctx.fillText(endSpacersReal, 1000, 1200);

            // ctx.fillText('no EarthClips', 0, 1500);
            // ctx.fillText(noEarthClipsReal, 1000, 1500);







        };

        useEffect(() => {
            draw(() => {resetView()    });

        }, [
        mainWidth,
        mainHeight,
        subWidth,
        subHeight,
        spacingBetweenColumns,
        spacingFromTopBottom,
        spacingFromSide,
        columnWidth,
        internalHorizontalSpacing,
        internalVerticalSpacing,
        zoom,
        offset,
        drawTrigger,
        showRibbonContent,
        activeTab,
        maxPanels
        ]);

    // --- Zoom and Pan Handlers ---
        useEffect(() => {
        const canvas = canvasRef.current;
        const handleWheel = (e) => {
            e.preventDefault();
            const rect = canvas.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;
            const zoomAmount = e.deltaY > 0 ? -0.01 : 0.01;
            const newZoom = clampZoom(zoom + zoomAmount);
            const scale = newZoom / zoom;
            const newOffsetX = mouseX - scale * (mouseX - offset.x);
            const newOffsetY = mouseY - scale * (mouseY - offset.y);
            setZoom(newZoom);
            setOffset({ x: newOffsetX, y: newOffsetY });
        };
        canvas.addEventListener('wheel', handleWheel);
        return () => canvas.removeEventListener('wheel', handleWheel);
        }, [zoom, offset]);

        useEffect(() => {
        const canvas = canvasRef.current;
        const handleMouseDown = (e) => {
            setIsPanning(true);
            setLastPan({ x: e.clientX, y: e.clientY });
        };
        const handleMouseMove = (e) => {
            if (isPanning) {
            const dx = e.clientX - lastPan.x;
            const dy = e.clientY - lastPan.y;
            setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
            setLastPan({ x: e.clientX, y: e.clientY });
            }
        };
        const handleMouseUp = () => setIsPanning(false);
        canvas.addEventListener('mousedown', handleMouseDown);
        canvas.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            canvas.removeEventListener('mousedown', handleMouseDown);
            canvas.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
        }, [isPanning, lastPan]);

        useEffect(() => {
        const canvas = canvasRef.current;
        const getDistance = (touches) => {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        };

        const handleTouchStart = (e) => {
            if (e.touches.length === 2) {
            setTouchDistance(getDistance(e.touches));
            } else if (e.touches.length === 1) {
            setIsPanning(true);
            setLastPan({ x: e.touches[0].clientX, y: e.touches[0].clientY });
            }
        };

        const handleTouchMove = (e) => {
            if (e.touches.length === 2 && touchDistance) {
            const newDistance = getDistance(e.touches);
            const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            const scale = newDistance / touchDistance;
            const newZoom = clampZoom(zoom * scale);
            const canvasRect = canvas.getBoundingClientRect();
            const canvasX = centerX - canvasRect.left;
            const canvasY = centerY - canvasRect.top;
            const offsetX = canvasX - scale * (canvasX - offset.x);
            const offsetY = canvasY - scale * (canvasY - offset.y);
            setZoom(newZoom);
            setOffset({ x: offsetX, y: offsetY });
            setTouchDistance(newDistance);
            } else if (e.touches.length === 1 && isPanning) {
            const dx = e.touches[0].clientX - lastPan.x;
            const dy = e.touches[0].clientY - lastPan.y;
            setOffset((prev) => ({ x: prev.x + dx, y: prev.y + dy }));
            setLastPan({ x: e.touches[0].clientX, y: e.touches[0].clientY });
            }
        };

        const handleTouchEnd = () => {
            setIsPanning(false);
            setTouchDistance(null);
        };

        canvas.addEventListener('touchstart', handleTouchStart);
        canvas.addEventListener('touchmove', handleTouchMove);
        canvas.addEventListener('touchend', handleTouchEnd);
        canvas.addEventListener('touchcancel', handleTouchEnd);
        return () => {
            canvas.removeEventListener('touchstart', handleTouchStart);
            canvas.removeEventListener('touchmove', handleTouchMove);
            canvas.removeEventListener('touchend', handleTouchEnd);
            canvas.removeEventListener('touchcancel', handleTouchEnd);
        };
        }, [zoom, offset, isPanning, lastPan, touchDistance]);



          const [shouldExport, setShouldExport] = useState(false);
          const [shouldExportToCoords, setShouldExportToCoords] = useState(false);


          useEffect(() => {
            if (shouldExport) {
              const timer = setTimeout(() => {
                exportToPDF();
                setShouldExport(false); // Reset
              }, 100); // Allow short delay for render (tweak this if needed)

              return () => clearTimeout(timer);
            }
          }, [shouldExport]);

          useEffect(() => {
            if (shouldExportToCoords) {
              const timer = setTimeout(() => {
                handleExportCoords();
                setShouldExportToCoords(false); // Reset
              }, 100); // Allow short delay for render (tweak this if needed)

              return () => clearTimeout(timer);
            }
          }, [shouldExportToCoords]);

        const resetView = () => {

            if (deviceType === "phone") {
                setZoom(0.07);  // Default zoom
                setOffset({ x: 0, y: 0 });  // Default pan
            }
            else {
                setZoom(0.08);  // Default zoom
                setOffset({ x: 100, y: 10 });  // Default pan
            }
        };
        const exportToPDF = () => {

            setMostLeftPdf()


            const pdfScale = 1 / 10

            setIsExporting(true);
            // Use the same base coordinates as in the draw function
            const mainX_pdf = 3000*pdfScale ;
            const mainY_pdf = 2000*pdfScale ;
            const pageBorderX_pdf = (mainX_pdf - 3000*pdfScale) ;
            const pageBorderY_pdf = (mainY_pdf - 2000*pdfScale);
            const pageBorderWidth_pdf = (mainWidth + 4500)*pdfScale;
            const pageBorderHeight_pdf = (mainHeight + 3500)*pdfScale;

            // Create an off-screen canvas that will hold the full export image.
            const exportCanvas = document.createElement("canvas");
            exportCanvas.width = pageBorderWidth_pdf;
            exportCanvas.height = pageBorderHeight_pdf;
            const exportCtx = exportCanvas.getContext("2d");

            exportCtx.fillStyle = "lightgray";
            exportCtx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);

            // Draw the page border at (0, 0)
            exportCtx.fillStyle = "white";
            exportCtx.fillRect(0, 0, pageBorderWidth_pdf, pageBorderHeight_pdf);
            exportCtx.lineWidth = 5;
            exportCtx.strokeStyle = "black";
            exportCtx.strokeRect(0, 0, pageBorderWidth_pdf, pageBorderHeight_pdf);

            // Draw the main rectangle shifted so that (mainX, mainY) becomes:
            const drawMainX_pdf = 3000*pdfScale - pageBorderX_pdf;
            const drawMainY_pdf = 2000*pdfScale - pageBorderY_pdf;

            const mainWidth_pdf = mainWidth*pdfScale;
            const mainHeight_pdf = mainHeight*pdfScale;

            // stripes for main rectangle
            const stripeWidth = 5;
            for (let x = drawMainX_pdf; x < drawMainX_pdf + mainWidth_pdf; x += stripeWidth * 2) {
                exportCtx.fillStyle = "lightgray";
                exportCtx.fillRect(x, drawMainY_pdf, stripeWidth, mainHeight_pdf);
            }
            exportCtx.lineWidth = 1;
            exportCtx.strokeStyle = "black";
            exportCtx.strokeRect(drawMainX_pdf, drawMainY_pdf, mainWidth_pdf, mainHeight_pdf);

            // Title Block
            const titleBlock_pdfX = mainX_pdf - 2500*pdfScale;
            const titleBlock_pdfY = mainY_pdf + mainHeight_pdf + 200*pdfScale;
            const titleBlock_pdfWidth = mainWidth_pdf -1500*pdfScale;
            const titleBlock_pdfHeight = 900*pdfScale;

            exportCtx.strokeStyle = 'black';
            exportCtx.strokeRect(titleBlock_pdfX , titleBlock_pdfY, titleBlock_pdfWidth, titleBlock_pdfHeight);

            if (mainWidth > 8900) {
                // Roof legend
                const roofLegend_pdfX = mainX_pdf+ 4000*pdfScale; ;
                const roofLegend_pdfY = mainY_pdf + mainHeight_pdf + 450*pdfScale;
                const roofLegend_pdfWidth = 700*pdfScale;
                const roofLegend_pdfHeight = 350*pdfScale;
                exportCtx.strokeRect(roofLegend_pdfX, roofLegend_pdfY, roofLegend_pdfWidth, roofLegend_pdfHeight);
                exportCtx.fillStyle = 'black';
                exportCtx.font = '18px Arial';
                exportCtx.fillText('Roof', roofLegend_pdfX + 180*pdfScale, roofLegend_pdfY + 550*pdfScale);

                // Draw ROOF rectangle with fill and a border
                for (let x = roofLegend_pdfX; x < roofLegend_pdfX + roofLegend_pdfWidth; x += stripeWidth * 2) {
                    exportCtx.fillStyle = 'lightgray';
                    exportCtx.fillRect(x, roofLegend_pdfY, stripeWidth, roofLegend_pdfHeight);
                }

                // Panel legend
                const panelLegend_pdfX = mainX_pdf + 5000*pdfScale;
                const panelLegend_pdfY = mainY_pdf + mainHeight_pdf + 450*pdfScale;
                const panelLegend_pdfWidth = 700*pdfScale;
                const panelLegend_pdfHeight = 350*pdfScale;
                exportCtx.strokeRect(panelLegend_pdfX, panelLegend_pdfY, panelLegend_pdfWidth, panelLegend_pdfHeight);
                exportCtx.fillStyle = 'black';
                exportCtx.font = '18px Arial';
                exportCtx.fillText('Panel', panelLegend_pdfX + 180*pdfScale, panelLegend_pdfY + 550*pdfScale);
                exportCtx.fillStyle = 'lightgreen';
                exportCtx.strokeStyle = 'darkgreen';
                exportCtx.fillRect(panelLegend_pdfX, panelLegend_pdfY, panelLegend_pdfWidth, panelLegend_pdfHeight);

                //Legend text
                const legendText_pdfX = mainX_pdf + 2300*pdfScale;
                const legendText_pdfY = mainY_pdf + mainHeight_pdf + 400*pdfScale;
                exportCtx.fillStyle = 'black';
                exportCtx.font = '22px Arial';
                //exportCtx.fillText('LEGEND:', legendText_pdfX , legendText_pdfY);
            }

            // Pannel Column Array
            const subWidth_pdf = subWidth*pdfScale;
            const subHeight_pdf = subHeight*pdfScale;

            //Calculate spacing




            // const usableWidth = mainWidth - 2 * spacingFromSide; //spacingFromSide //
            // const usableHeight = mainHeight - 2 * spacingFromTopBottom; //spacingFromTopBottom //



            // const subColumnsPerMainColumn = columnWidth;
            // const subColumnWidth =
            //     subWidth * subColumnsPerMainColumn +
            //     internalHorizontalSpacing * (subColumnsPerMainColumn - 1);

            // const noOfMainColumns =
            //     Math.floor(
            //         (usableWidth + spacingBetweenColumns) / (subColumnWidth + spacingBetweenColumns)
            //     );

            // const widtOfCompletColumns=noOfMainColumns*(subColumnsPerMainColumn*(subWidth + internalHorizontalSpacing)) +spacingBetweenColumns*(noOfMainColumns-1)
            // const usableWidthLeft=usableWidth -widtOfCompletColumns - spacingBetweenColumns
            // const noOfLastSubColums = Math.floor(usableWidthLeft/(subWidth + internalHorizontalSpacing))


            // const subRectanglesPerColumn = Math.floor(
            //     (usableHeight + internalVerticalSpacing) / (subHeight + internalVerticalSpacing)
            // );

            // const totalSubHeight =  subRectanglesPerColumn * subHeight + (subRectanglesPerColumn - 1) * internalVerticalSpacing;
            // const totalSubWidth = noOfMainColumns * subColumnWidth + (noOfMainColumns - 1) * spacingBetweenColumns;
            // let totalSubWithPlusResWaarde = totalSubWidth
            // if (noOfLastSubColums > 0) {
            //     totalSubWithPlusResWaarde =  widtOfCompletColumns+ spacingBetweenColumns+(noOfLastSubColums*(subWidth + internalHorizontalSpacing))
            // } else {
            //     totalSubWithPlusResWaarde = widtOfCompletColumns
            // }

            // const leftMargin = (mainWidth - totalSubWithPlusResWaarde) / 2; //spacingFromSide //
            // const topMargin = (mainHeight - totalSubHeight) / 2; //spacingFromTopBottom //


            // const allColumns = (noOfMainColumns * subColumnsPerMainColumn) + noOfLastSubColums

            // const maxFittingPanels = (allColumns * subRectanglesPerColumn);





            // let subColumnsForMax = Math.floor(maxFittingPanels / (subRectanglesPerColumn));
            // let mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
            // let panelsInLastSubColumn =subRectanglesPerColumn
            // let endSpacersReal =allColumns*4
            // let noEarthClipsReal =allColumns*(subRectanglesPerColumn-1)
            // if (maxPanels <= maxFittingPanels) {
            //         subColumnsForMax = Math.floor(maxPanels / (subRectanglesPerColumn));
            //         mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
            //         panelsInLastSubColumn =maxPanels - subColumnsForMax*subRectanglesPerColumn
            //         endSpacersReal =subColumnsForMax *4 + Math.ceil(panelsInLastSubColumn/ subRectanglesPerColumn)*4
            //         noEarthClipsReal =subColumnsForMax*(subRectanglesPerColumn-1) + Math.max(0, panelsInLastSubColumn-1)
            //     }

            
            const usableWidth = mainWidth - 2 * spacingFromSide; //spacingFromSide //
            const usableHeight = mainHeight - 2 * spacingFromTopBottom; //spacingFromTopBottom //



            const subColumnsPerMainColumn = columnWidth;
            const subColumnWidth =
                subWidth * subColumnsPerMainColumn +
                internalHorizontalSpacing * (subColumnsPerMainColumn - 1);

            const noOfMainColumns =
                Math.floor(
                    (usableWidth + spacingBetweenColumns) / (subColumnWidth + spacingBetweenColumns)
                );

            const widtOfCompletColumns=noOfMainColumns*(subColumnsPerMainColumn*(subWidth + internalHorizontalSpacing)) +spacingBetweenColumns*(noOfMainColumns-1)
            const usableWidthLeft=usableWidth -widtOfCompletColumns - spacingBetweenColumns
            const noOfLastSubColums = Math.floor(usableWidthLeft/(subWidth + internalHorizontalSpacing))


            const subRectanglesPerColumn = Math.floor(
                (usableHeight + internalVerticalSpacing) / (subHeight + internalVerticalSpacing)
            );

            const totalSubHeight =  subRectanglesPerColumn * subHeight + (subRectanglesPerColumn - 1) * internalVerticalSpacing;
            const totalSubWidth = noOfMainColumns * subColumnWidth + (noOfMainColumns - 1) * spacingBetweenColumns;
            let totalSubWithPlusResWaarde = totalSubWidth
            if (noOfLastSubColums > 0) {
                totalSubWithPlusResWaarde =  widtOfCompletColumns+ spacingBetweenColumns+(noOfLastSubColums*(subWidth + internalHorizontalSpacing))
            } else {
                totalSubWithPlusResWaarde = widtOfCompletColumns
            }

            const leftMargin = (mainWidth - totalSubWithPlusResWaarde) / 2; //spacingFromSide //
            const topMargin = (mainHeight - totalSubHeight) / 2; //spacingFromTopBottom //


            const allColumns = (noOfMainColumns * subColumnsPerMainColumn) + noOfLastSubColums

            const maxFittingPanels = (allColumns * subRectanglesPerColumn);





            let subColumnsForMax = Math.floor(maxFittingPanels / (subRectanglesPerColumn));
            let mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
            let panelsInLastSubColumn =subRectanglesPerColumn
            let endSpacersReal =allColumns*4
            let noEarthClipsReal =allColumns*(subRectanglesPerColumn-1)
            let noBracketsReal =allColumns*(subRectanglesPerColumn*2+2)
            let noAntiTampersReal =allColumns*(subRectanglesPerColumn*2+2)
            if (maxPanels <= maxFittingPanels) {
                    subColumnsForMax = Math.floor(maxPanels / (subRectanglesPerColumn));
                    mainColumnsForMax = Math.floor(subColumnsForMax / subColumnsPerMainColumn);
                    panelsInLastSubColumn =maxPanels - subColumnsForMax*subRectanglesPerColumn
                    endSpacersReal =subColumnsForMax *4 + Math.ceil(panelsInLastSubColumn/ subRectanglesPerColumn)*4
                    noEarthClipsReal =subColumnsForMax*(subRectanglesPerColumn-1) + Math.max(0, panelsInLastSubColumn-1)
                    noBracketsReal =subColumnsForMax*(subRectanglesPerColumn*2+2)+ panelsInLastSubColumn*2+2
                    noAntiTampersReal =subColumnsForMax*(subRectanglesPerColumn*2+2)+ panelsInLastSubColumn*2+2
                }



            //ReScale for PDF
            const subColumnWidth_pdf = subColumnWidth*pdfScale;
            const leftMargin_pdf = leftMargin*pdfScale;
            const topMargin_pdf = topMargin*pdfScale;
            const spacingBetweenColumns_pdf = spacingBetweenColumns*pdfScale;
            const internalVerticalSpacing_pdf = internalVerticalSpacing*pdfScale;
            const internalHorizontalSpacing_pdf = internalHorizontalSpacing*pdfScale;
            const mountingCentre_pdf = mountingCentre*pdfScale;
            const widtOfCompletColumns_pdf=widtOfCompletColumns*pdfScale
            const usableWidthLeft_pdf=usableWidthLeft*pdfScale
            const totalSubwidthPlusResWaarde_pdf=totalSubWithPlusResWaarde*pdfScale

            //count and number panels
            let panel_counter_pdf = 1;

            //Annotations
            exportCtx.font = '12px Arial';
            exportCtx.fillStyle = 'black';
            exportCtx.textAlign = 'center';
            exportCtx.textBaseline = 'middle';

            //Column start
            exportCtx.beginPath();
            exportCtx.moveTo(mainX_pdf, -1250*pdfScale+mainY_pdf);
            exportCtx.lineTo(mainX_pdf+mainWidth_pdf, -1250*pdfScale+mainY_pdf);
            exportCtx.strokeStyle = 'grey';
            exportCtx.lineWidth = 1;
            exportCtx.stroke();
            exportCtx.fillStyle = 'black';
            exportCtx.font = '18px Arial';
            exportCtx.fillText('Column Start', mainX_pdf-1200*pdfScale, -1250*pdfScale+mainY_pdf);

            //Column End
            exportCtx.beginPath();
            exportCtx.moveTo(mainX_pdf, -800*pdfScale+mainY_pdf);
            exportCtx.lineTo(mainX_pdf+mainWidth_pdf, -800*pdfScale+mainY_pdf);
            exportCtx.strokeStyle = 'grey';
            exportCtx.lineWidth = 1;
            exportCtx.stroke();
            exportCtx.fillStyle = 'black';
            exportCtx.font = '18px Arial';
            exportCtx.fillText('Column End', mainX_pdf-1200*pdfScale, -800*pdfScale+mainY_pdf);

            //Bracket Postiion Horsiontal
            exportCtx.beginPath();
            exportCtx.moveTo(mainX_pdf, -200*pdfScale+mainY_pdf);
            exportCtx.lineTo(mainX_pdf+mainWidth_pdf, -200*pdfScale+mainY_pdf);
            exportCtx.strokeStyle = 'grey';
            exportCtx.lineWidth = 1;
            exportCtx.stroke();

            exportCtx.fillStyle = 'black';
            exportCtx.font = '18px Arial';
            exportCtx.fillText('Bracket Position From B0  ', mainX_pdf-1050*pdfScale, -200*pdfScale+mainY_pdf);

            //Bracket Postiion Vertical
            exportCtx.beginPath();
            exportCtx.moveTo(mainX_pdf-250*pdfScale, mainY_pdf);
            exportCtx.lineTo(mainX_pdf-250*pdfScale, mainY_pdf+mainHeight_pdf);
            exportCtx.strokeStyle = 'grey';
            exportCtx.lineWidth = 1;
            exportCtx.stroke();

        ///create blank table (to export to csv) to hold the data
            const tableData = [];





        // Draw the sub-panels
            for (let mainCol = 0; mainCol < noOfMainColumns; mainCol++) {
                for (let subCol = 0; subCol < subColumnsPerMainColumn; subCol++) {
                    for (let row = 0; row < subRectanglesPerColumn; row++) {

                        if (panel_counter_pdf > maxPanels)
                            break;

                        const x = //left of panel
                            mainX_pdf +
                            leftMargin_pdf +
                            mainCol * (subColumnWidth_pdf + spacingBetweenColumns_pdf) +
                            subCol * (subWidth_pdf + internalHorizontalSpacing_pdf);
                        const y = //top of panel
                            mainY_pdf +
                            topMargin_pdf +
                            row * (subHeight_pdf + internalVerticalSpacing_pdf);

                        //panel
                        exportCtx.fillStyle = 'lightgreen';
                        exportCtx.strokeStyle = 'darkgreen';
                        exportCtx.fillRect(x, y, subWidth_pdf, subHeight_pdf);
                        exportCtx.strokeRect(x, y, subWidth_pdf, subHeight_pdf);
                        exportCtx.fillStyle = 'black';
                        exportCtx.font = '18px Arial';
                        exportCtx.fillText('Panel ' + panel_counter_pdf++, x + subWidth_pdf / 2, y + subHeight_pdf / 2);


                        // // column start
                        // if (subCol === 0) {
                        //     exportCtx.font = '18px Arial';
                        //     exportCtx.fillText('CS' + (mainCol + 1) + ': ' + (Math.round((x)/pdfScale)-2000), x, -1000*pdfScale+mainY_pdf);
                        //     exportCtx.font = '18px Arial';
                        //     exportCtx.fillText('|', x, -800*pdfScale+mainY_pdf);
                        //     // append Columns start tp tableData
                        //     tableData.push({ Column: 'CS' + (mainCol + 1), Position: Math.round((x)/pdfScale)-2000 });


                        // }


                        //Bracket 1 & 2 HOR

                        const B1_pdf = x + subWidth_pdf / 2 - mountingCentre_pdf / 2;
                        const B2_pdf = x + subWidth_pdf / 2 + mountingCentre_pdf / 2;

                        if (mainCol === 0) {


                            if (subCol === 0) {
                                setMostLeftPdf((B1_pdf- mainX_pdf))
                                exportCtx.font = '18px Arial';
                                exportCtx.fillText(  "CS" +(mainCol + 1) +" :" +  (Math.round((B1_pdf-x)/pdfScale)) + " left of B0. (" + (Math.round((x-mainX_pdf)/pdfScale)) + " from side.)" , x, -1000*pdfScale+mainY_pdf);
                                exportCtx.font = '18px Arial';
                                exportCtx.fillText("|" ,  x, -800*pdfScale+mainY_pdf);

                                if (panel_counter_pdf  <= 2){
                                exportCtx.fillText('B|0', B1_pdf, y);
                                    } else exportCtx.fillText('|', B1_pdf, y);
                                exportCtx.fillText("B0", B1_pdf, -600*pdfScale+mainY_pdf);
                                exportCtx.fillText( "( " +Math.round((B1_pdf-mainX_pdf) /pdfScale) + " from side)  0" , B1_pdf, -400*pdfScale+mainY_pdf);
                                exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);



                        } else {
                            exportCtx.fillText('|', B1_pdf, y);
                            exportCtx.fillText('B1', B1_pdf, -600*pdfScale+mainY_pdf);
                            exportCtx.fillText(Math.round((B1_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B1_pdf, -400*pdfScale+mainY_pdf);
                            exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);
                        }
                        } else {


                        if (subCol === 0) {
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('CS' + (mainCol + 1) + ': ' + (Math.round((x-mainX_pdf-mostLeftPdf)))/pdfScale, x, -1000*pdfScale+mainY_pdf);
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('|', x, -800*pdfScale+mainY_pdf);


                        }


                        }





                        if (mainCol != 0) {
                            exportCtx.fillText('|', B1_pdf, y);
                            exportCtx.fillText('B1', B1_pdf, -600*pdfScale+mainY_pdf);
                            exportCtx.fillText(Math.round((B1_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B1_pdf, -400*pdfScale+mainY_pdf);
                            exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);
                        }



                        // append B1 tp tableData
                        //tableData.push({ Column:'B1', Position:Math.round((B1_pdf-mainX_pdf)/pdfScale)});

                        exportCtx.font = '18px Arial';
                        exportCtx.fillText('|', B2_pdf, y);
                        exportCtx.fillText('B2', B2_pdf, -600*pdfScale+mainY_pdf);
                        exportCtx.fillText(Math.round((B2_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B2_pdf, -400*pdfScale+mainY_pdf);
                        exportCtx.fillText('|', B2_pdf, -200*pdfScale+mainY_pdf);
                        // append B2 tp tableData
                        //tableData.push({ Column:'B2', Position:Math.round((B2_pdf-mainX_pdf)/pdfScale)});



                        // // Bracket 1 & 2 VER
                        // exportCtx.font = '18px Arial';
                        // exportCtx.fillText(Math.round((y- mainY_pdf - internalVerticalSpacing_pdf / 2)/pdfScale) + ' to top    --', -1000*pdfScale+mainX_pdf, y);
                        // if (row === subRectanglesPerColumn - 1) {
                        //     exportCtx.font = '18px Arial';
                        //     exportCtx.fillText(Math.round((y- mainY_pdf  + subHeight_pdf + internalVerticalSpacing / 2)/pdfScale) + ' to top    --', -1000*pdfScale+mainX_pdf, y + subHeight_pdf);
                        //     exportCtx.fillText('|', B1_pdf, y + subHeight_pdf);
                        //     exportCtx.fillText('|', B2_pdf, y + subHeight_pdf);
                        // }

                        // Bracket 1 & 2 VER
                        if (mainCol === 0) {

                            if(subCol === 0) {

                                if (row === 0) {
                                    setMostTopPdf(y- mainY_pdf - internalVerticalSpacing_pdf / 2)

                                    exportCtx.font = '18px Arial';
                                    exportCtx.fillText("( B0: " + Math.round((y- mainY_pdf - internalVerticalSpacing_pdf / 2))/pdfScale + " to ridge)  0        --    ", -1000*pdfScale+mainX_pdf, y);

                                } else {
                                    exportCtx.font = '18px Arial';
                                    exportCtx.fillText(Math.round(y- mainY_pdf - internalVerticalSpacing_pdf / 2-mostTopPdf)/pdfScale + ' to top bracket (B0) --    ', -1000*pdfScale+mainX_pdf, y);

                                }
                            }

                        }

                        if (row === subRectanglesPerColumn - 1) {
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText(Math.round(y- mainY_pdf  + subHeight_pdf + internalVerticalSpacing_pdf / 2-mostTopPdf)/pdfScale + ' to top bracket (B0) --    ', -1000*pdfScale+mainX_pdf, y + subHeight_pdf);
                            exportCtx.fillText('|', B1_pdf, y + subHeight_pdf);
                            exportCtx.fillText('|', B2_pdf, y + subHeight_pdf);
                        }

                        // column start end
                        if (subCol === subColumnsPerMainColumn - 1) {
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('CE' + (mainCol + 1) + ': ' + (Math.round((x + subWidth_pdf)/pdfScale)-mostLeftPdf/pdfScale-3000), x + subWidth_pdf, -1450*pdfScale+mainY_pdf);
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('|', x + subWidth_pdf, -1250*pdfScale+mainY_pdf);
                            // append Columns end tp tableData
                            //tableData.push({ Column: 'CE' + (mainCol + 1), Position: Math.round((x + subWidth_pdf)/pdfScale)-2000 });
                        }

                        //guidelines
                        exportCtx.beginPath();
                        exportCtx.moveTo(B1_pdf, y);
                        exportCtx.lineTo(B1_pdf, y + subHeight_pdf);
                        exportCtx.strokeStyle = 'black';
                        exportCtx.lineWidth = 2;
                        exportCtx.stroke();
                        exportCtx.beginPath();
                        exportCtx.moveTo(B2_pdf, y);
                        exportCtx.lineTo(B2_pdf, y + subHeight_pdf);
                        exportCtx.strokeStyle = 'black';
                        exportCtx.lineWidth = 2;
                        exportCtx.stroke();
                    }
                }
            }

            if (noOfLastSubColums > 0) {

            for (let mainCol = mainColumnsForMax; mainCol < mainColumnsForMax+1; mainCol++) {
                for (let subCol = 0; subCol < noOfLastSubColums; subCol++) {
                    for (let row = 0; row < subRectanglesPerColumn; row++) {

                        if (panel_counter_pdf > maxPanels)
                            break;

                        const x = //left of panel
                            mainX_pdf +
                            leftMargin_pdf +
                            // widtOfCompletColumns_pdf + spacingBetweenColumns_pdf +
                            mainCol * (subColumnWidth_pdf + spacingBetweenColumns_pdf) +
                            subCol * (subWidth_pdf + internalHorizontalSpacing_pdf);
                        const y = //top of panel
                            mainY_pdf +
                            topMargin_pdf +
                            row * (subHeight_pdf + internalVerticalSpacing_pdf);

                        //panel
                        exportCtx.fillStyle = 'lightgreen';
                        exportCtx.strokeStyle = 'darkgreen';
                        exportCtx.fillRect(x, y, subWidth_pdf, subHeight_pdf);
                        exportCtx.strokeRect(x, y, subWidth_pdf, subHeight_pdf);
                        exportCtx.fillStyle = 'black';
                        exportCtx.font = '18px Arial';
                        exportCtx.fillText('Panel ' + panel_counter_pdf++, x + subWidth_pdf / 2, y + subHeight_pdf / 2);


                        // // column start



                        //Bracket 1 & 2 HOR

                        const B1_pdf = x + subWidth_pdf / 2 - mountingCentre_pdf / 2;
                        const B2_pdf = x + subWidth_pdf / 2 + mountingCentre_pdf / 2;

                        // if (mainCol === 0) {


                        //     if (subCol === 0) {
                        //         setMostLeftPdf((B1_pdf- mainX_pdf))
                        //         exportCtx.font = '18px Arial';
                        //         exportCtx.fillText(  "CS" +(mainCol + 1) +" :" +  (Math.round((mostLeftPdf-(x-mainX_pdf))/pdfScale)) + " left of B0. (" + (Math.round((x-mainX_pdf)/pdfScale)) + " from side.)" , x, -1000*pdfScale+mainY_pdf);
                        //         exportCtx.font = '18px Arial';
                        //         exportCtx.fillText("|" ,  x, -800*pdfScale+mainY_pdf);

                        //         exportCtx.fillText('|', B1_pdf, y);
                        //         exportCtx.fillText("B0", B1_pdf, -600*pdfScale+mainY_pdf);
                        //         exportCtx.fillText( "( " +Math.round(mostLeftPdf /pdfScale) + " from side)  0" , B1_pdf, -400*pdfScale+mainY_pdf);
                        //         exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);



                        // } else {
                        //     exportCtx.fillText('|', B1_pdf, y);
                        //     exportCtx.fillText('B1', B1_pdf, -600*pdfScale+mainY_pdf);
                        //     exportCtx.fillText(Math.round((B1_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B1_pdf, -400*pdfScale+mainY_pdf);
                        //     exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);
                        // }
                        // } else {


                        if (subCol === 0) {
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('CS' + (mainCol + 1) + ': ' + (Math.round((x-mainX_pdf-mostLeftPdf)))/pdfScale, x, -1000*pdfScale+mainY_pdf);
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('|', x, -800*pdfScale+mainY_pdf);
                            exportCtx.fillText('|', B1_pdf, y);
                            if (panel_counter_pdf> maxPanels){
                                exportCtx.fillText('|', B1_pdf, y+subHeight_pdf);
                            }


                        }


                        // }





                        if (mainCol != 0) {
                            exportCtx.fillText('|', B1_pdf, y);
                            exportCtx.fillText('B1', B1_pdf, -600*pdfScale+mainY_pdf);
                            exportCtx.fillText(Math.round((B1_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B1_pdf, -400*pdfScale+mainY_pdf);
                            exportCtx.fillText('|', B1_pdf, -200*pdfScale+mainY_pdf);
                            if (panel_counter_pdf> maxPanels){
                                exportCtx.fillText('|', B1_pdf, y+subHeight_pdf);
                            }
                        }



                        // append B1 tp tableData
                        //tableData.push({ Column:'B1', Position:Math.round((B1_pdf-mainX_pdf)/pdfScale)});

                        exportCtx.font = '18px Arial';
                        exportCtx.fillText('|', B2_pdf, y);
                        exportCtx.fillText('B2', B2_pdf, -600*pdfScale+mainY_pdf);
                        exportCtx.fillText(Math.round((B2_pdf-mainX_pdf)/pdfScale-mostLeftPdf/pdfScale), B2_pdf, -400*pdfScale+mainY_pdf);
                        exportCtx.fillText('|', B2_pdf, -200*pdfScale+mainY_pdf);
                        if (panel_counter_pdf> maxPanels){
                                exportCtx.fillText('|', B2_pdf, y+subHeight_pdf);
                            }
                        // append B2 tp tableData
                        //tableData.push({ Column:'B2', Position:Math.round((B2_pdf-mainX_pdf)/pdfScale)});



                        // // Bracket 1 & 2 VER
                        // exportCtx.font = '18px Arial';
                        // exportCtx.fillText(Math.round((y- mainY_pdf - internalVerticalSpacing_pdf / 2)/pdfScale) + ' to top    --', -1000*pdfScale+mainX_pdf, y);
                        // if (row === subRectanglesPerColumn - 1) {
                        //     exportCtx.font = '18px Arial';
                        //     exportCtx.fillText(Math.round((y- mainY_pdf  + subHeight_pdf + internalVerticalSpacing / 2)/pdfScale) + ' to top    --', -1000*pdfScale+mainX_pdf, y + subHeight_pdf);
                        //     exportCtx.fillText('|', B1_pdf, y + subHeight_pdf);
                        //     exportCtx.fillText('|', B2_pdf, y + subHeight_pdf);
                        // }

                        // Bracket 1 & 2 VER
                        if (mainCol === 0) {

                            if(subCol === 0) {

                                if (row === 0) {
                                    setMostTopPdf(y- mainY_pdf - internalVerticalSpacing_pdf / 2)

                                    exportCtx.font = '18px Arial';
                                  //  exportCtx.fillText("( B0: " + Math.round((y- mainY_pdf - internalVerticalSpacing_pdf / 2))/pdfScale + " to ridge)  0        --    ", -1000*pdfScale+mainX_pdf, y);

                                } else {
                                    exportCtx.font = '18px Arial';
                                  //  exportCtx.fillText(Math.round(y- mainY_pdf - internalVerticalSpacing_pdf / 2-mostTopPdf)/pdfScale + ' to top bracket (B0) --    ', -1000*pdfScale+mainX_pdf, y);

                                }
                            }

                        }

                        if (row === subRectanglesPerColumn - 1) {
                            exportCtx.font = '18px Arial';
                          //  exportCtx.fillText(Math.round(y- mainY_pdf  + subHeight_pdf + internalVerticalSpacing_pdf / 2-mostTopPdf)/pdfScale + ' to top bracket    --    ', -1000*pdfScale+mainX_pdf, y + subHeight_pdf);
                            exportCtx.fillText('|', B1_pdf, y + subHeight_pdf);
                            exportCtx.fillText('|', B2_pdf, y + subHeight_pdf);
                            if (panel_counter_pdf> maxPanels){
                                exportCtx.fillText('|', B1_pdf, y+subHeight_pdf);
                                exportCtx.fillText('|', B2_pdf, y+subHeight_pdf);
                            }
                        }

                        // column start end
                        if (subCol === subColumnsPerMainColumn - 1) {
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('CE' + (mainCol + 1) + ': ' + (Math.round((x + subWidth_pdf)/pdfScale)-mostLeftPdf/pdfScale-3000), x + subWidth_pdf, -1450*pdfScale+mainY_pdf);
                            exportCtx.font = '18px Arial';
                            exportCtx.fillText('|', x + subWidth_pdf, -1250*pdfScale+mainY_pdf);
                            // append Columns end tp tableData
                            //tableData.push({ Column: 'CE' + (mainCol + 1), Position: Math.round((x + subWidth_pdf)/pdfScale)-2000 });
                        }

                        //guidelines
                        exportCtx.beginPath();
                        exportCtx.moveTo(B1_pdf, y);
                        exportCtx.lineTo(B1_pdf, y + subHeight_pdf);
                        exportCtx.strokeStyle = 'black';
                        exportCtx.lineWidth = 2;
                        exportCtx.stroke();
                        exportCtx.beginPath();
                        exportCtx.moveTo(B2_pdf, y);
                        exportCtx.lineTo(B2_pdf, y + subHeight_pdf);
                        exportCtx.strokeStyle = 'black';
                        exportCtx.lineWidth = 2;
                        exportCtx.stroke();
                    }
                }
            }


                        }




                        //Legend NOtes

                        const noteText_pdfY = mainY_pdf + mainHeight_pdf + 400*pdfScale;
                        exportCtx.fillStyle = 'black';
                        exportCtx.font = '8px Arial';
                        exportCtx.textAlign = 'left';

                        exportCtx.font = '18px Arial';
                        exportCtx.fillText('TITLE:', mainX_pdf-2200*pdfScale , noteText_pdfY-8);
                        exportCtx.fillText('SOLAR PANEL LAYOUT', mainX_pdf-2200*pdfScale , noteText_pdfY+12);
                        exportCtx.fillText(pdfName, mainX_pdf-2200*pdfScale , noteText_pdfY+32);


            //  PDF
            const pdfWidth = pageBorderWidth_pdf;
            const pdfHeight = pageBorderHeight_pdf;

            // Create the jsPDF document.
            const pdf = new jsPDF({
            orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
            unit: "pt",
            format: [pdfWidth, pdfHeight],
            });

            // Convert the off-screen canvas to an image.
            const imgData = exportCanvas.toDataURL("image/png");

            // Add the image and then save the PDF.
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

            // Add logo
            pdf.addImage(logo_H_black_img, "PNG", pdfWidth-100-2000*pdfScale, titleBlock_pdfY+10, 2000*pdfScale,(2000*pdfScale)/1829*666 );

            // Add text
            const margin = 30;


            const maxWidth = pdfWidth - margin * 2;

            pdf.setFontSize(8);
            pdf.setTextColor(100);

            if (mainWidth > 6500) {

            // Suplementary Info
            pdf.text(
                'Roof Height                   : '+ mainHeight +'mm\n' +
                'Roof Width                    : '+ mainWidth+'mm\n\n'+
                'Panel Height                  : '+ subHeight+'mm\n' +
                'Panel Width                   : '+ subWidth+'mm\n\n'+
                'Panel Mounting Centre : '+ mountingCentre+'mm\n'+
                'Walkway Width             : '+ spacingBetweenColumns+'mm\n',
                300 , pdfHeight-120, {
                maxWidth: maxWidth,
                align: 'left',
                });

//noOfLastSubColums

                if (panelsInLastSubColumn> 0) {
                    pdf.text(
                    'Panels per Column     : '+subRectanglesPerColumn + ' ['+panelsInLastSubColumn+' in last]\n',
                    450 , pdfHeight-120, {
                    maxWidth: maxWidth,
                    align: 'left',
                    });
                }  else {
                    pdf.text(
                    'Panels per Column      : '+subRectanglesPerColumn +'\n',
                    450 , pdfHeight-120, {
                    maxWidth: maxWidth,
                    align: 'left',
                    });

                }
                if ( noOfLastSubColums> 0) {
                    pdf.text(
                    'Columns                     : '+ (subColumnsForMax+1)+' ['+ subColumnsForMax+' + Partial Column]\n' +
                    'Columns per Cluster   : '+ subColumnsPerMainColumn +'\n'+
                    'Clusters                      : '+ (mainColumnsForMax+1) + ' ['+mainColumnsForMax+' + Partial Cluster]\n',
                    450 , pdfHeight-110, {
                    maxWidth: maxWidth,
                    align: 'left',
                    });

                } else {

                    pdf.text(
                    'Columns                     : '+ subColumnsForMax+ '\n'+
                    'Columns per Cluster   : '+ subColumnsPerMainColumn +'\n'+
                    'Clusters                      : '+ mainColumnsForMax +'\n',
                    450 , pdfHeight-110, {
                    maxWidth: maxWidth,
                    align: 'left',
                    });
                }
                    
                    pdf.text(
                    'Panels                        : '+ (panel_counter_pdf-1) +'\n'+
                    'Brackets                     : '+ noBracketsReal+ '\n' +
                    'Anti Tamper Clamps  : '+noAntiTampersReal +'\n'+
                    'End Spacers              : '+ endSpacersReal +'\n'+
                    'Earthing Clips            : '+ noEarthClipsReal +'\n',
                    450 , pdfHeight-81, {
                    maxWidth: maxWidth,
                    align: 'left',
                    });

            }

            const disclaimerText = `This drawing is generated based on user-provided input. It is the sole responsibility of the user to ensure all measurements are accurate and verified on site. DeoSolar accepts no liability for errors resulting from incorrect or incomplete input. Use of this drawing is at the client’s own risk.\nDeoSolar and its logo are the property of the company. All content is protected by copyright and may not be reproduced or distributed without permission.`;

            pdf.text(disclaimerText, 50, pdfHeight - margin, {
            maxWidth: maxWidth,
            align: 'left',
            });

            //Date
            const now = new Date();
            const date = now.toISOString().slice(0, 10); // YYYY-MM-DD
            const time = now.toTimeString().slice(0, 8).replace(/:/g, '-'); // HH-MM-SS

            pdf.text(`Generated on: ${date} ${time}`, 800*pdfScale, pdfHeight - 50,{
                maxWidth: maxWidth,
                align: 'left',
                });

            //Export
            pdf.save(`DeoSolar_${pdfName}_${date}_${time}.pdf`);
            setIsExporting(false);

        };


    //windload

    const handleExportWindload = async () => {
        setShowCoordsModal(false)

        setIsExporting(true);

        // Timestamp
        const now = new Date();
        const date = now.toISOString().slice(0, 10);
        const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
        const timetext = now.toTimeString().slice(0, 8);
        // Initialize PDF
        const doc = new jsPDF('p', 'mm', 'a4');
        const { height: pageHeight, width: pageWidth } = doc.internal.pageSize;

        // Layout settings
        const startX = 10;
        const startY = 40;         // Space for header
        const rowHeight = 8;
        const headerHeight = rowHeight * 2;
        const marginBottom = 20;



        // Common pagination and header helpers
        let page = 1;
        let rowY = startY;
        const addHeader = () => {
          doc.addImage(logo_img, 'PNG', 10, 10, 42, (42 / 1829) * 666);
          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.text('Wind Load report: ' , 60, 20);
          doc.setFontSize(10);
          doc.text(`Generated on: ${date} ${timetext}`, pageWidth - 130, pageHeight - 10);
          doc.text(`Page ${page}`, pageWidth - 30, pageHeight - 10);
        };
        const checkAddPage = (headersNext=null) => {
          if (rowY + rowHeight + marginBottom > pageHeight) {
            doc.addPage(); page++; rowY = startY;
            addHeader();
            if (headersNext != null) {
                headersNext.headers.forEach((h, i) => {
                    doc.rect(headersNext.xPos, rowY, headersNext.colWidths[i], headerHeight);
                    doc.text(h, headersNext.xPos + 2, rowY + 7);
                    headersNext.xPos += headersNext.colWidths[i];
                  });
                  rowY += headerHeight;

            }
          }
        };


        // Start first page
        addHeader();
        doc.setFont('helvetica', 'normal');

        doc.text(  `Reference specification SANS 10160-3`, startX, rowY);
        rowY += rowHeight;
        let x = startX;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Basic Wind Speed (Vb)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(windSpeed*100)/100 +" m/s") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight*2);
        doc.rect(x, rowY, 55 , rowHeight*2);
        doc.text("Terrain Description", x + 2, rowY + 7);
        doc.text(String(categoryName) , startX+60, rowY+7);
        rowY += rowHeight*2;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Terrain Exposure Category ", x + 2, rowY + 7);
        doc.text(String(categoryId) , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Exposure Cofficient (Cr)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(exposureCoef*100)/100)  , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.text("Topography Factor (Ct)", x + 2, rowY + 7);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text(String(Math.ceil(topographyCoef*100)/100)  , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.text("Design Wind Speed (Vd)", x + 2, rowY + 7);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text(String(Math.ceil(designWindSpeed*100)/100 +" m/s") , startX+60, rowY+7);
        rowY += rowHeight;
        rowY += rowHeight*.5;

        doc.setFont('helvetica', 'normal');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Air Density", x + 2, rowY + 7);
        doc.text(String(Math.ceil(airDensity*100)/100 +" kg/m3") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Wind Pressure (q)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(designWindPressure*100)/100 +" Pa") , startX+60, rowY+7);
        rowY += rowHeight;
        rowY += rowHeight*.5;

        doc.setFont('helvetica', 'normal');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Panel Length (L)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(subWidth*100)/100 +" mm") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Panel Width (W)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(subHeight*100)/100 +" mm") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Panel Area (A)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(panelArea*100)/100 +" m2") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Roof Angle (degrees)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(roofAngle*100)/100 +" degrees") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Force Coefficient (Cf)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(upliftCoef*100)/100) , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Uplift Force (F)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(upliftForce*100)/100 +" kN") , startX+60, rowY+7);
        rowY += rowHeight;
        rowY += rowHeight*.5;

        doc.setFont('helvetica', 'normal');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Shear Force Coefficient (Cf)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(shearCoef*100)/100) , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Shear Force (Fshear)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(shearForce*100)/100 +" kN") , startX+60, rowY+7);
        rowY += rowHeight;
        rowY += rowHeight*.5;

        doc.setFont('helvetica', 'normal');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Panel Weight", x + 2, rowY + 7);
        doc.text(String(Math.ceil(panelWeight*100)/100 +" kg") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Mounting Weight", x + 2, rowY + 7);
        doc.text(String(Math.ceil(mountingWeight*100)/100 +" kg") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight);
        doc.rect(x, rowY, 55 , rowHeight);
        doc.text("Ultimate Uplift (U)", x + 2, rowY + 7);
        doc.text(String(Math.ceil(ultimateUpliftForce*100)/100 +" kN") , startX+60, rowY+7);
        rowY += rowHeight;
        doc.setFont('helvetica', 'bold');
        doc.rect(x, rowY, pageWidth - startX * 2, rowHeight*2);
        doc.rect(x, rowY, 55 , rowHeight*2);
        doc.text("Bracket Check", x + 2, rowY + 7);
        doc.text(String(loadIsCompliant) , startX+60, rowY+7);
        rowY += rowHeight*2;
        rowY += rowHeight;

        doc.setFont('helvetica', 'normal'); doc.setFontSize(10);

        doc.text(  `This document is generated based on user-provided input.
It is the sole responsibility of the user to ensure all measurements are accurate and
verified on site. DeoSolar accepts no liability for errors resulting from incorrect or
incomplete input. Use of this drawing is at the client's own risk. DeoSolar and its
logo are the property of the company. All content is protected by copyright and may
not be reproduced or distributed without permission.`, startX, rowY);
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;




        // Save PDF
        doc.save(`windLoad_${date}_${time}.pdf`);

        setIsExporting(false);
      };




    // --- BOQ Handlers ---
    const handleExportCoords = async () => {
        setShowCoordsModal(false)

        setIsExporting(true);

        // Timestamp
        const now = new Date();
        const date = now.toISOString().slice(0, 10);
        const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
        const timetext = now.toTimeString().slice(0, 8);
        // Initialize PDF
        const doc = new jsPDF('p', 'mm', 'a4');
        const { height: pageHeight, width: pageWidth } = doc.internal.pageSize;

        // Layout settings
        const startX = 10;
        const startY = 40;         // Space for header
        const rowHeight = 10;
        const headerHeight = rowHeight * 2;
        const marginBottom = 20;



        // Common pagination and header helpers
        let page = 1;
        let rowY = startY;
        const addHeader = () => {
          doc.addImage(logo_img, 'PNG', 10, 10, 42, (42 / 1829) * 666);
          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.text('Coordinates: ' +String(pdfName), 60, 20);
          doc.setFontSize(10);
          doc.text(`Generated on: ${date} ${timetext}`, pageWidth - 130, pageHeight - 10);
          doc.text(`Page ${page}`, pageWidth - 30, pageHeight - 10);
        };
        const checkAddPage = (headersNext=null) => {
          if (rowY + rowHeight + marginBottom > pageHeight) {
            doc.addPage(); page++; rowY = startY;
            addHeader();
            if (headersNext != null) {
                headersNext.headers.forEach((h, i) => {
                    doc.rect(headersNext.xPos, rowY, headersNext.colWidths[i], headerHeight);
                    doc.text(h, headersNext.xPos + 2, rowY + 7);
                    headersNext.xPos += headersNext.colWidths[i];
                  });
                  rowY += headerHeight;

            }
          }
        };


        // Start first page
        addHeader();
        doc.setFont('helvetica', 'normal');

        if (yCoordinate.length < 0) {
            // Prepare Y values and headers
            const yValues = yCoordinate.map(({ y }) => y);
            const yHeaders = yCoordinate.map(({ row }) => `Y${row}`);

          // Single table: Name, X, Y1...Yn
          const headers = ['Name', 'X', ...yHeaders];
          // First column double width
          const availableWidth = pageWidth - startX * 2;
          const totalCols = headers.length;
          const smallColWidth = availableWidth / (totalCols + 1);
          const firstColWidth = smallColWidth * 2;
          const colWidths = headers.map((_, i) => (i === 0 ? firstColWidth : smallColWidth));

          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.text('Bracket Positions', startX, rowY);
          rowY += rowHeight;

          doc.setFont('helvetica', 'normal'); doc.setFontSize(12);
          doc.text('The Table below gives the positions for Bracket Centers measured a distance of:\n - X mm form the side of the roof and;\n - Y mm from the top of the roof.\n\n Input Parameters are given on the last Page.', startX, rowY);
        rowY += rowHeight;
        rowY += rowHeight;
        rowY += rowHeight;


        rowY += rowHeight;


        doc.setFont('helvetica', 'normal'); doc.setFontSize(10);
          // Draw table header
          doc.setFont('helvetica', 'bold');
          let xPos = startX;
          headers.forEach((h, i) => {
            doc.rect(xPos, rowY, colWidths[i], headerHeight);
            doc.text(h, xPos + 2, rowY + 7);
            xPos += colWidths[i];
          });
          rowY += headerHeight;

          // Draw rows
          doc.setFont('helvetica', 'normal');
          coordinates.forEach(item => {
            checkAddPage({headers, xPos: startX, rowY, colWidths});
            let x = startX;
            const values = [item.id, item.x, ...yValues];
            values.forEach((v, i) => {
              doc.rect(x, rowY, colWidths[i], rowHeight);
              doc.text(String(v), x + 2, rowY + 7);
              x += colWidths[i];
            });
            rowY += rowHeight;
          });

        } else {
          // Then print coordinates table (ID, X)

          rowY += rowHeight;
          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.text('Bracket Positions', startX, rowY);
          rowY += rowHeight;

          doc.setFont('helvetica', 'normal'); doc.setFontSize(12);
          doc.text(`This Document consist of two tables:\n
    Table 1 below gives the positions for Bracket Centers from measured from the top of the roof in mm.\n
    Table 2 that follows gives the positions for Bracket Centers from measured from the side of the roof in mm.\n
Input Parameters are given on the last Page.'
            `, startX, rowY);
            rowY += rowHeight;
            rowY += rowHeight;
            rowY += rowHeight;
            rowY += rowHeight;

            doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
            doc.text('TABLE 1: Distance from top of roof.', startX, rowY);
            rowY += rowHeight;
            doc.setFont('helvetica', 'normal'); doc.setFontSize(10);


          const headers1 = ['Row', 'Distance\n of Top Bracket Centre\n to Roof Top [mm]'];
          const availW1 = pageWidth - startX * 2;
          const smallW1 = 50;
          const firstW1 = 40;
          const colW1 = [firstW1, smallW1];
          // Header2
          doc.setFont('helvetica', 'bold');
          let x1 = startX;
          headers1.forEach((h, i) => {
            doc.rect(x1, rowY, colW1[i], headerHeight);
            //align text to the center

            doc.text(h, x1 + 2, rowY + 7, );

            x1 += colW1[i];
          });
          rowY += headerHeight;


          // Rows2
          doc.setFont('helvetica', 'normal');
          yCoordinate.forEach(item => {
            checkAddPage({headers:headers1, xPos:startX, rowY:rowY, colWidths:colW1});
            let xcell = startX;
            [('Row: ' +item.row), item.y].forEach((val, i) => {
              doc.rect(xcell, rowY, colW1[i], rowHeight);
              if (val === 'Row: 0'){
                doc.text(String('From Top of Roof'), xcell + 2, rowY + 7);
              }
              else {


              doc.text(String(val), xcell + 2, rowY + 7);
              }
              xcell += colW1[i];
            });
            rowY += rowHeight;
          });

          // Add spacing before coords table
          rowY += rowHeight;
          doc.text('THIS SPACE IS LEFT BLANK INTENTIONALLY, PLEASE TURN OVER', startX, rowY);
          doc.addPage(); page++; rowY = startY;
          addHeader();

          doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
          doc.text('TABLE 2: Distance from side of roof.', startX, rowY);
          rowY += rowHeight;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(10);

          // Then print coordinates table (ID, X)
          const headers2 = ['Name', 'Distance Along Roof'];
          const availW2 = pageWidth - startX * 2;
          const smallW2 = 40;
          const firstW2 = 60;
          const colW2 = [firstW2, smallW2];
          // Header2
          doc.setFont('helvetica', 'bold');
          let x2 = startX;
          headers2.forEach((h, i) => {
            doc.rect(x2, rowY, colW2[i], headerHeight);
            doc.text(h, x2 + 2, rowY + 7, );
            x2 += colW2[i];
          });
          rowY += headerHeight;
          // Rows2
          doc.setFont('helvetica', 'normal');
          coordinates.forEach(item => {
            checkAddPage({headers:headers2, xPos:startX, rowY:rowY, colWidths:colW2});
            let xcell = startX;
            [item.id, item.x].forEach((val, i) => {
              doc.rect(xcell, rowY, colW2[i], rowHeight);
              doc.text(String(val), xcell + 2, rowY + 7);
              xcell += colW2[i];
            });
            rowY += rowHeight;
          });
        }
        rowY += rowHeight;
        doc.text('THIS SPACE IS LEFT BLANK INTENTIONALLY, PLEASE TURN OVER', startX, rowY);
        doc.addPage(); page++; rowY = startY;
        addHeader();

        rowY += rowHeight;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
        doc.text('Input Parameters: ' +String(pdfName), startX+2 , rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.setFont('helvetica', 'normal'); doc.setFontSize(12);
        doc.text('Roof: ' , startX+2, rowY);
        doc.text('('+ String(mainHeight/1000) +'x' + String(mainWidth/1000)+') m (HxW)', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Panel: ' , startX+2, rowY);
        doc.text('('+ String(subHeight) +'x' + String(subWidth)+') mm (HxW)', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Panels: ' , startX+2, rowY);
        doc.text('('+ String(paramsNoColumns) +'x' +String(columnWidth)+') Columns x '+String(paramsNoRows) +' Rows = '+String(paramsNoPanels)+' Panels', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Walkway Spacing: ' , startX+2, rowY);
        doc.text( String(spacingBetweenColumns)+ ' mm', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Mounting Centres: ' , startX+2, rowY);
        doc.text( String(mountingCentre)+ ' mm', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Horisontal Spacing: ' , startX+2, rowY);
        doc.text( String(internalHorizontalSpacing)+ ' mm', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Bracket Spacing: ' , startX+2, rowY);
        doc.text( String(internalVerticalSpacing)+ ' mm', startX+60, rowY);

        doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Offset from Top/bottom: ' , startX+2, rowY);
        doc.text( String(spacingFromTopBottom)+ ' mm', startX+60, rowY);

        // doc.rect(startX, rowY+2, pageWidth - startX * 2, headerHeight);
        rowY += rowHeight;
        doc.text('Offset from Side: ' , startX+2, rowY);
        doc.text( String(spacingFromSide)+ ' mm', startX+60, rowY);

        rowY += rowHeight;
        doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
        doc.text('DISCLAIMER', startX+2 , rowY);


        rowY += rowHeight;

        doc.setFont('helvetica', 'normal'); doc.setFontSize(10);

        doc.text(  `This document is generated based on user-provided input.
It is the sole responsibility of the user to ensure all measurements are accurate and
verified on site. DeoSolar accepts no liability for errors resulting from incorrect or
incomplete input. Use of this drawing is at the client's own risk. DeoSolar and its
logo are the property of the company. All content is protected by copyright and may
not be reproduced or distributed without permission.`, startX, rowY);
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;
rowY += rowHeight;




        // Save PDF
        doc.save(`Coordinates_${date}_${time}.pdf`);

        setIsExporting(false);
      };

    const ExportCoords =() =>
    {
        setDrawTrigger(prev => !prev); // Trigger the draw
        setShouldExportToCoords(true);

    }

    const handleAddClick = () => {
            setModalName(pdfName || '');
            setDrawTrigger(prev => !prev); // Trigger the draw
            setIsModalOpen(true);

        };
        const confirmAdd = () => {
            const newItem = { pdfName, mainWidth, mainHeight, subWidth, subHeight, columnWidth, internalVerticalSpacing, internalHorizontalSpacing, spacingBetweenColumns, spacingFromTopBottom, spacingFromSide, mountingCentre, noPanels, noBrackets, noEarthClips, noAntiTamperClips, noEndSpacers,panelName, bracketType,paramsNoColumns, paramsNoRows, paramsNoPanels, maxPanels  };
            setBOQData(prev => [...prev, newItem]);
            setMainWidth(0);
            setMainHeight(0);
            setNoOfRoofs(prev => prev + 1,);
            setIsModalOpen(false);
            setDrawTrigger(prev => !prev); // Trigger the draw
            setCurrentUnsaved(false);

        };
        const cancelAdd = () => {
            setModalName('');
            setIsModalOpen(false);
            setDrawTrigger(prev => !prev); // Trigger the
            setBracketType('Please Select')
        };
        const handleClearAll = () => {
            setBOQData([]);
            setPDFName('Roof: 1');
            setMainWidth(0);
            setMainHeight(0);

            setMaxPanels(1000);
            setNoOfRoofs(0);
            setDrawTrigger(prev => !prev); // Trigger the draw
        }

    const handleExportWind = () => {

        setWindloadCalcTrigger(prev => !prev); // Trigger the Calc

        const timeout = setTimeout(() => {
                handleExportWindload()
          }, 1000);

          // Optional cleanup (e.g., if component unmounts)
          return () => clearTimeout(timeout);




    }





        return (
        <div>
            {!showConsent && (
            <>
                <div className='RIBBON'
                    style={{
                        display: "flex",
                        background: 'lightgray',
                        flexDirection: "column",
                        justifyContent: "space-between",
                        maxHeight: "100vh",
                        maxWidth: "100vw",
                        width: "100vw",
                        height: "100vh",
                    }}
                >
                    {showTC && (
                                            <div style={{

                                                background: "#fff",
                                                borderTop: "2px solid #000",
                                                padding: "20px",
                                                zIndex: 9999,
                                                boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",

                                            }}>
                                                <h2 style={{ marginBottom: 10 }}>TERMS AND CONDITIONS</h2>
                                                <h2>Terms & Conditions</h2>
                                            <p><strong>1. Accuracy of Information</strong><br />
                                                The content provided is for general information only. DeoSolar is not responsible for errors, omissions, or inaccuracies. Users must verify all measurements and data before relying on it.
                                            </p>
                                            <p><strong>2. User Responsibility</strong><br />
                                                Any actions taken based on the content of this website are at the user's own risk. DeoSolar shall not be liable for any loss or damages arising from its use.
                                            </p>
                                            <p><strong>3. Intellectual Property</strong><br />
                                                All content, including text, graphics, logos, and software, is the property of DeoSolar and protected by copyright laws. Reproduction or redistribution without permission is prohibited.
                                            </p>
                                            <p><strong>4. Privacy</strong><br />
                                                We respect your privacy and handle your data in accordance with the Protection of Personal Information Act (POPIA). No personal information is collected without consent.
                                            </p>
                                            <p><strong>5. Cookies</strong><br />
                                                This site uses cookies to enhance user experience. By continuing to browse, you consent to the use of cookies.
                                            </p>
                                            <p><strong>6. Changes</strong><br />
                                            DeoSolar may update these terms at any time. Continued use of the site means you accept any changes.
                                            </p>
                                                <h2 style={{ marginBottom: 10 }}>Disclaimer</h2>
                                                <p style={{ marginBottom: 10 }}>
                                                This drawing is generated based on user-provided input. It is the sole responsibility of the user to ensure all measurements are accurate and verified on site. DeoSolar accepts no liability for errors resulting from incorrect or incomplete input or interpretation thereoff. Use of this drawing is at the client’s own risk.\nDeoSolar and its logo are the property of the company. All content is protected by copyright and may not be reproduced or distributed without permission.
                                                </p>
                                                <button onClick={() => setShowTC(false)} style={{ padding: "10px 20px", background: "black", color: "white", border: "none" }}>
                                                I Understand & Accept
                                                </button>
                                            </div>
                    )}
                    <div>

                        <Ribbon
                        showRibbonContent={showRibbonContent}
                        setShowRibbonContent={setShowRibbonContent}
                        setDrawTrigger={setDrawTrigger}>
                            <RibbonTabs
                                tabs={[
                                    { value: "main", label: "Roof" },
                                    { value: "sub", label: "Panels" },
                                    { value: "column", label: "Spacing" },
                                    { value: "layout", label: "Offset" },
                                    { value: "boq", label: "BOQ" },
                                    {value: "air", label: "Wind Loading"},
                                ]}
                                activeTab={activeTab}
                                onTabChange={setActiveTab}
                            />
                            {showTotals && (
                                <div className='panel-wrapper'>
                                    <div className={`action-panel-total-roofs ${deviceType}`}
                                    >
                                        <div className={`action-panel-total-roofs-text ${deviceType}`}>
                                            <p className={`action-panel-total-roofs-header ${deviceType}`}>
                                                No of Roofs:
                                            </p>
                                            <p className={`action-panel-total-roofs-value ${deviceType}`}>
                                                {noOfRoofs}
                                            </p>
                                        </div>
                                        <div className={`action-panel-total-roofs-text ${deviceType}`}>
                                            <p className={`action-panel-total-roofs-header ${deviceType}`}>
                                                Total Panels:
                                            </p>
                                            <p className={`action-panel-total-roofs-value ${deviceType}`}>
                                                {totalPanels}
                                            </p>
                                        </div>
                                        <div className={`action-panel-total-roofs-text ${deviceType}`}>
                                            <p className={`action-panel-total-roofs-header ${deviceType}`}>
                                                Total Brackets:
                                            </p>
                                            <p className={`action-panel-total-roofs-value ${deviceType}`}>
                                                {totalBrackets}
                                            </p>
                                        </div>
                                        <div className='action-panel-current-roof-buttons'>
                                            <button
                                                className="action-panel-button"
                                                onClick={handleClearAll}
                                                style={{backgroundColor: "var(--error-color)"}}>

                                                <img className="action-panel-image" src={mop_img} alt="Clear"  />
                                            </button>
                                            {(activeTab !== "boq") && (
                                                <button
                                                    className="action-panel-button"
                                                    onClick={()=> {
                                                        setActiveTab("boq");
                                                }}>
                                                    <img className="action-panel-image" src={table_img} alt="BOQ"  />
                                                </button>
                                            )}
                                        </ div>
                                    </div>
                                </div>
                            )}

                                {activeTab === "main" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button-spacer'></button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>ROOF:</h2>
                                            <ResponsiveInput
                                                label="Width [mm]:"
                                                value={mainWidth}
                                                onChange={(e) => setMainWidth(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(mainWidth);
                                                    setMainWidth("");
                                                }}
                                                onBlur={() =>
                                                    setMainWidth(mainWidth === "" ? tempValue : Math.max(0, mainWidth))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Roof Width",
                                                        "Width of the Roof in mm. (Length of top ridge)."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Length on Incline [mm]:"
                                                value={mainHeight}
                                                onChange={(e) => setMainHeight(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(mainHeight);
                                                    setMainHeight("");
                                                }}
                                                onBlur={() =>
                                                    setMainHeight(mainHeight === "" ? tempValue : Math.max(0, mainHeight))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Roof Length",
                                                        "Length from the end of the roof to the top ridge in mm."
                                                    )
                                                }
                                            />
                                        </div>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("sub")}
                                            >
                                                <img className='tab-nav-image' src={arrow_forward_img} alt="next"></img>
                                        </button>

                                    </div>
                                )}
                                {activeTab === "sub" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("main")}
                                            >
                                                <img className='tab-nav-image' src={arrow_back_img}  alt="back"></img>
                                        </button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>PANELS:</h2>


                                            <ResponsiveInput
                                                label="Maximum No of Panels:"
                                                value={maxPanels}
                                                onChange={(e) => {
                                                    setMaxPanels(parseInt(e.target.value) || 0)

                                                }
                                                }
                                                onClick={() => {
                                                    setTempValue(subWidth);
                                                    setMaxPanels("");
                                                }}
                                                onBlur={() =>
                                                    setMaxPanels(maxPanels === "" ? tempValue : Math.max(0, maxPanels))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Maximum No of Panels",
                                                        "Limits the amount of panels on a roof to a predefined amount. Defaults to 1000"
                                                    )
                                                }
                                            />

                                            <ResponsiveInput
                                                label="Long Side of Panel [mm]:"
                                                value={subWidth}
                                                onChange={(e) => {
                                                    setSubWidth(parseInt(e.target.value) || 0)
                                                    setPanelName('Please Select');
                                                    setPanelId(0);
                                                }
                                                }
                                                onClick={() => {
                                                    setTempValue(subWidth);
                                                    setSubWidth("");
                                                }}
                                                onBlur={() =>
                                                    setSubWidth(subWidth === "" ? tempValue : Math.max(0, subWidth))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Landscape Panel Width",
                                                        "Width of the panel, in mm, when it is mounted in a Landscape orientation. Typically labeled as Panel Length."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Short Side of Panel [mm]:"
                                                value={subHeight}
                                                onChange={(e) => {
                                                    setSubHeight(parseInt(e.target.value) || 0);
                                                    setPanelName('Please Select');
                                                    setPanelId(0);
                                                }}
                                                onClick={() => {
                                                    setTempValue(subHeight);
                                                    setSubHeight("");
                                                }}
                                                onBlur={() =>
                                                    setSubHeight(subHeight === "" ? tempValue : Math.max(0, subHeight))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Landscape Panel Length",
                                                        "Height of the panel, in mm, when it is mounted in a Landscape orientation. Typically labeled as Panel Width."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Mounting Centre [mm]:"
                                                value={mountingCentre}
                                                onChange={(e) => {
                                                    setMountingCentre(parseInt(e.target.value) || 0)
                                                    setPanelName('Please Select');
                                                    setPanelId(0);
                                                }}
                                                onClick={() => {
                                                    setTempValue(mountingCentre);
                                                    setMountingCentre("");
                                                }}
                                                onBlur={() =>
                                                    setMountingCentre(
                                                        mountingCentre === "" ? tempValue : Math.max(0, mountingCentre)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Mounting Centre",
                                                        "Distance between mounting points on the Panel in mm. This should be taken from the manufacturers datasheet."
                                                    )
                                                }
                                            />

                                            <PanelSelector
                                                    setSubWidth={setSubWidth}
                                                    setSubHeight={setSubHeight}
                                                    setMountingCentre={setMountingCentre}
                                                    setPanelId={setPanelId}
                                                    panelId= {panelId}
                                                    setPanelName={setPanelName}
                                                    panelName={panelName}
                                                    mountingCentre={mountingCentre}
                                                    subHeight={subHeight}
                                                    subWidth={subWidth}
                                                    setPanelWeight={setPanelWeight}
                                                    deviceType={deviceType}

                                                />

                                            <ResponsiveInput
                                                label="Panel Weight [kg]:"
                                                value={panelWeight}
                                                onChange={(e) => {
                                                    setPanelWeight(parseInt(e.target.value) || 0)
                                                    setPanelName('Please Select');
                                                    setPanelId(0);
                                                }}
                                                onClick={() => {
                                                    setTempValue(mountingCentre);
                                                    setPanelWeight("");
                                                }}
                                                onBlur={() =>
                                                    setPanelWeight(
                                                        panelWeight === "" ? tempValue : Math.max(0, panelWeight)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Panel Weight",
                                                        "Panel Weight in kg. This should be taken from the manufacturers datasheet. Defaults to 23kg"
                                                    )
                                                }
                                            />







                                        </div>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("column")}
                                            >
                                                <img className='tab-nav-image' src={arrow_forward_img}  alt="next"></img>
                                        </button>

                                    </div>

                                )}
                                {activeTab === "column" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("sub")}
                                        >
                                            <img className='tab-nav-image' src={arrow_back_img}  alt="back"></img>
                                        </button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>SPACING:</h2>
                                            <ResponsiveInput
                                                label="Panels Per Column [no]:"
                                                value={columnWidth}
                                                onChange={(e) => setColumnWidth(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(columnWidth);
                                                    setColumnWidth("");
                                                }}
                                                onBlur={() =>
                                                    setColumnWidth(columnWidth === "" ? tempValue : Math.max(0, columnWidth))
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Panels Per Column",
                                                        "The number of panels in each column, before space is made for a walkway. It is recomended that columns be 2-3 panels wide. Wider than this will limit access to panels in the centre of the column at a later stage."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Bracket Spacing [mm]:"
                                                value={internalVerticalSpacing}
                                                onChange={(e) =>
                                                    setInternalVerticalSpacing(parseInt(e.target.value) || 0)
                                                }
                                                onClick={() => {
                                                    setTempValue(internalVerticalSpacing);
                                                    setInternalVerticalSpacing("");
                                                }}
                                                onBlur={() =>
                                                    setInternalVerticalSpacing(
                                                        internalVerticalSpacing === "" ? tempValue : Math.max(0, internalVerticalSpacing)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Vertical Bracket Spacing",
                                                        "Vertical spacing between panels in mm. This defaults to 17mm which is the width of DeoSolars Brackets."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Horizontal Spacing [mm]:"
                                                value={internalHorizontalSpacing}
                                                onChange={(e) =>
                                                    setInternalHorizontalSpacing(parseInt(e.target.value) || 0)
                                                }
                                                onClick={() => {
                                                    setTempValue(internalHorizontalSpacing);
                                                    setInternalHorizontalSpacing("");
                                                }}
                                                onBlur={() =>
                                                    setInternalHorizontalSpacing(
                                                        internalHorizontalSpacing === "" ? tempValue : Math.max(0, internalHorizontalSpacing)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Horizontal Spacing",
                                                        "Horizontal spacing between panels in mm. This is not the walkway spacing and should be as small as the manufacturer of the panel allows. Defaults to 0mm."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Walkway Spacing [mm]:"
                                                value={spacingBetweenColumns}
                                                onChange={(e) => setSpacingBetweenColumns(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(spacingBetweenColumns);
                                                    setSpacingBetweenColumns("");
                                                }}
                                                onBlur={() =>
                                                    setSpacingBetweenColumns(
                                                        spacingBetweenColumns === "" ? tempValue : Math.max(0, spacingBetweenColumns)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Walkway Spacing",
                                                        "Spacing between columns in mm. This is the walkway spacing and should be as wide as possible to allow access to all panels."
                                                    )
                                                }
                                            />
                                        </div>

                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("layout")}
                                        >
                                                <img className='tab-nav-image' src={arrow_forward_img}  alt="next"></img>
                                                </button>
                                        </div>
                                )}
                                {activeTab === "layout" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("column")}
                                        >
                                            <img className='tab-nav-image' src={arrow_back_img}  alt="back"></img>
                                        </button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>OFFSET:</h2>
                                            <ResponsiveInput
                                                label="Offset from Top [mm]:"
                                                value={spacingFromTopBottom}
                                                onChange={(e) => setSpacingFromTopBottom(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(spacingFromTopBottom);
                                                    setSpacingFromTopBottom("");
                                                }}
                                                onBlur={() =>
                                                    setSpacingFromTopBottom(
                                                        spacingFromTopBottom === "" ? tempValue : Math.max(0, spacingFromTopBottom)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Offset from Top",
                                                        "Distance from top of the highest panel to the top of the roof or ridge. In mm. Defaults to 300mm."
                                                    )
                                                }
                                            />
                                            <ResponsiveInput
                                                label="Offset from Side [mm]:"
                                                value={spacingFromSide}
                                                onChange={(e) => setSpacingFromSide(parseInt(e.target.value) || 0)}
                                                onClick={() => {
                                                    setTempValue(spacingFromSide);
                                                    setSpacingFromSide("");
                                                }}
                                                onBlur={() =>
                                                    setSpacingFromSide(
                                                        spacingFromSide === "" ? tempValue : Math.max(0, spacingFromSide)
                                                    )

                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "Offset from Side",
                                                        "Distance from first panel/columb to the side of the roof or ridge. In mm. Defaults to 300mm."
                                                    )
                                                }
                                            />
                                        </div>
                                        <button className='tab-nav-button-spacer'
                                        onClick={() => setActiveTab("boq")}
                                        >
                                            <img className='tab-nav-image' src={arrow_forward_img}  alt="next"></img>
                                        </button>
                                    </div>


                                )}
                                {activeTab === "boq" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("main")}
                                        >
                                            <img className='tab-nav-image' src={arrow_back_img}  alt="back"></img>
                                        </button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>BOQ:</h2>

                                            <DynamicList
                                            setDrawTrigger={setDrawTrigger}
                                            BOQData={BOQData}
                                            setBOQData={setBOQData}
                                            pdfName={pdfName}
                                            setPDFName={setPDFName}
                                            noPanels={noPanels}
                                            setNoPanels={setNoPanels}
                                            noBrackets={noBrackets}
                                            setNoBrackets={setNoBrackets}
                                            noEarthClips={noEarthClips}
                                            setNoEarthClips={setNoEarthClips}
                                            noAntiTamperClips={noAntiTamperClips}
                                            setNoAntiTamperClips={setNoAntiTamperClips}
                                            noEndSpacers={noEndSpacers}
                                            setNoEndSpacers={setNoEndSpacers}
                                            mainWidth={mainWidth}
                                            setMainWidth={setMainWidth}
                                            mainHeight={mainHeight}
                                            setMainHeight={setMainHeight}
                                            subWidth={subWidth}
                                            setSubWidth={setSubWidth}
                                            subHeight={subHeight}
                                            setSubHeight={setSubHeight}
                                            columnWidth={columnWidth}
                                            setColumnWidth={setColumnWidth}
                                            internalVerticalSpacing={internalVerticalSpacing}
                                            setInternalVerticalSpacing={setInternalVerticalSpacing}
                                            internalHorizontalSpacing={internalHorizontalSpacing}
                                            setInternalHorizontalSpacing={setInternalHorizontalSpacing}
                                            spacingBetweenColumns={spacingBetweenColumns}
                                            setSpacingBetweenColumns={setSpacingBetweenColumns}
                                            spacingFromTopBottom={spacingFromTopBottom}
                                            setSpacingFromTopBottom={setSpacingFromTopBottom}
                                            spacingFromSide={spacingFromSide}
                                            setSpacingFromSide={setSpacingFromSide}
                                            mountingCentre={mountingCentre}
                                            setMountingCentre={setMountingCentre}
                                            noOfRoofs={noOfRoofs}
                                            setNoOfRoofs={setNoOfRoofs}
                                            exportToPDF ={exportToPDF}
                                            deviceType={deviceType}
                                            totalPanels={totalPanels}
                                            setTotalPanels={setTotalPanels}
                                            totalBrackets={totalBrackets}
                                            setTotalBrackets={setTotalBrackets}
                                            totalAntiTamperClips={totalAntiTamperClips}
                                            setTotalAntiTamperClips={setTotalAntiTamperClips}
                                            totalEndSpacers={totalEndSpacers}
                                            setTotalEndSpacers={setTotalEndSpacers}
                                            totalEarthClips={totalEarthClips}
                                            setTotalEarthClips={setTotalEarthClips}
                                            setShowExportModal={setShowExportModal}
                                            setActiveTab={setActiveTab}
                                            paramsNoColumns={paramsNoColumns}
                                            paramsNoRows={paramsNoRows}
                                            paramsNoPanels={paramsNoPanels}
                                            handleExportCoords={handleExportCoords}
                                            shouldExportToCoords={shouldExportToCoords}
                                            setShouldExportToCoords={setShouldExportToCoords}
                                            maxPanels={maxPanels}
                                            setMaxPanels={setMaxPanels}



                                            ></DynamicList>

                                        </div>
                                        <button className='tab-nav-button-spacer'></button>
                                    </div>


                                )}
                                {activeTab === "air" && (
                                    <div className={`input-container-row ${deviceType}`}>
                                        <button className='tab-nav-button'
                                                onClick={() => setActiveTab("main")}
                                        >
                                            <img className='tab-nav-image' src={arrow_back_img}  alt="back"></img>
                                        </button>
                                        <div className={`input-container ${deviceType}`}>
                                            <h2 className='ribbon-header'>Wind Loads:</h2>

                                                    <div className="footer-row"
                                                    style={{alignItems: (deviceType !='phone') ?  'flex-start':'center' }}>

                                                        <button className="action-panel-button"  onClick={handleExportWind} disabled={isExporting || categoryId === 0} >
                                                          <img className="action-panel-image" src={file_save_img} alt="Export"  />
                                                          <p className='action-panel-button-text'>
                                                            Wind Load Report
                                                          </p>
                                                        </button>

                                                        <button className="action-panel-button"  onClick={() => {
                                                                setActiveTab('sub')
                                                        }}>
                                                          <img className="action-panel-image" src={solar_power_img} alt="Add"  />
                                                           <p className='action-panel-button-text'>Adjust Panel Dimensions</p>
                                                        </button>
                                            </div>

                                            <PlaceSelector
                                                placeId={placeId}
                                                setPlaceId={setPlaceId}
                                                placeName={placeName}
                                                setPlaceName={setPlaceName}
                                                windSpeed={windSpeed}
                                                setWindSpeed={setWindSpeed}
                                                deviceType={deviceType}
                                                />

                                            <CatSelector
                                                categoryId={categoryId}
                                                setCategoryId={setCategoryId}
                                                categoryName={categoryName}
                                                setCategoryName={setCategoryName}
                                                catCoeficient={catCoeficient}
                                                setCatCoeficient={setCatCoeficient}
                                                deviceType={deviceType}
                                                />

                                            <ResponsiveInput
                                                label="Wind Speed [m/s]:"
                                                value={windSpeed}
                                                onChange={(e) => {
                                                    setWindSpeed(parseInt(e.target.value) || 0)
                                                    setPlaceName('Select (Opional)');
                                                    setPlaceId(0);
                                                }}
                                                onClick={() => {
                                                    setTempValue(windSpeed);
                                                    setWindSpeed("");
                                                }}
                                                onBlur={() =>
                                                    setWindSpeed(
                                                        windSpeed === "" ? tempValue : Math.max(0, windSpeed)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "WindSpeed",
                                                        "WindSpeed in m/s"
                                                    )
                                                }
                                            />

                                            <ResponsiveInput
                                                label="Roof Angle:"
                                                value={roofAngle}
                                                onChange={(e) => {
                                                    setRoofAngle(parseInt(e.target.value) || 0)

                                                }}
                                                onClick={() => {
                                                    setTempValue(roofAngle);
                                                    setRoofAngle("");
                                                }}
                                                onBlur={() =>
                                                    setRoofAngle(
                                                        roofAngle=== "" ? tempValue : Math.max(0, roofAngle)
                                                    )
                                                }
                                                helpAction={() =>
                                                    openModal(
                                                        "RoofAngle",
                                                        "Angle of the roof from the Horisontal in Degrees"
                                                    )
                                                }
                                            />





                                        </div>
                                        <button className='tab-nav-button-spacer'></button>
                                    </div>


                                )}

                        </Ribbon>
                        <div className='panel-wrapper'>
                            <div className={`action-panel-current-roof ${deviceType}`}>
                                <div className={`action-panel-current-roof-text ${deviceType}`}>
                                    <p className ={`current-roof-header ${deviceType}`} >
                                        Roof:
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{ color: (mainHeight===0 || mainWidth===0)?  "var(--error-color)": "var(--highlight-color)"}}>
                                        {mainHeight/1000}m (H)
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{ color: (mainHeight===0 || mainWidth===0)?  "var(--error-color)": "var(--highlight-color)"}}>
                                        {mainWidth/1000}m (w)
                                    </p>
                                </div>
                                <div className={`action-panel-current-roof-text ${deviceType}`}>
                                    <p className ={`current-roof-header ${deviceType}`}>
                                        Panel Size:
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{color: (subHeight===0 || subWidth===0)?  "var(--error-color)": "var(--highlight-color)" }}>
                                        {subHeight}mm (H)
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{ color: (subHeight===0 || subWidth===0)?  "var(--error-color)": "var(--highlight-color)"}}>
                                        {subWidth}mm (W)
                                    </p>
                                </div>
                                <div className={`action-panel-current-roof-text ${deviceType}`}>
                                    <p className ={`current-roof-header ${deviceType}`} >
                                        Panels:
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{ justifyContent: 'center', color: (paramsNoPanels===0 )?  "var(--error-color)": "var(--highlight-color)" }}>
                                        {paramsNoPanels} :
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{ color: (paramsNoPanels===0 )?  "var(--error-color)": "var(--highlight-color)" }}>
                                        {paramsNoRows} x ({paramsNoColumns}x{columnWidth})
                                    </p>
                                </div>
                                <div className={`action-panel-current-roof-text ${deviceType}`} style={{justifyContent: "flex-start" }}>
                                    <p className ={`current-roof-header ${deviceType}`} >
                                        Brackets:
                                    </p>
                                    <p className={`current-roof-value ${deviceType}`} style={{justifyContent: 'center', color: "var(--highlight-color)", fontWeight: '800', fontFamily: "'Open Sans','sans-serif'",  fontSize: '18px'}}>
                                        {paramsNoBrackets}
                                    </p>
                                </div>

                            </div>

                            <div className={`action-panel-current-roof ${deviceType}`}>
                                <div className='action-panel-current-roof-buttons'>
                                    <button className="action-panel-button"
                                        onClick={() => resetView()}

                                    >
                                        <img className="action-panel-image"src={reset_image_img} alt="Redraw"  />
                                        {deviceType === "phone" ? "" : "Redraw"}
                                    </button>
                                </div>
                                <div className='action-panel-current-roof-buttons'>
                                <button
                                                className="action-panel-button"
                                                onClick={handleClearAll}
                                                disabled={paramsNoPanels === 0 && BOQData.length === 0}
                                                >

                                                <img className="action-panel-image" src={mop_img} alt="Clear"  />
                                            </button>
                                </div>

                                <div className='action-panel-current-roof-buttons'>
                                    <button
                                        className="action-panel-button"
                                        disabled={paramsNoPanels === 0}
                                        onClick={handleAddClick}
                                    >
                                        <img className="action-panel-image" src={add_img} alt="Add"  />
                                        <p className='action-panel-button-text'>BOQ</p>
                                    </button>
                                </div>



                                <div className='action-panel-current-roof-buttons'>
                                    <button
                                        className="action-panel-button"
                                        onClick={() => setShowExportModal(true)}
                                        disabled={isExporting || paramsNoPanels === 0}
                                    >
                                            <img className="action-panel-image" src={picture_as_pdf_img} alt="to PDF"  />
                                            {deviceType === "phone" ? "" : "PDF"}
                                    </button>
                                </div>
                                <div className='action-panel-current-roof-buttons'>
                                    <button
                                            className="action-panel-button"
                                            onClick={() => {
                                                setDrawTrigger(prev => !prev);
                                                setShowCoordsModal(true);}}
                                            disabled={isExporting || paramsNoPanels === 0}

                                        >
                                            <img className="action-panel-image" src={file_save_img} alt="Coords"  />

                                            {deviceType === "phone" ? "" : "Table"}
                                    </button>
                                </div>

                            </div>
                        </div>
                        <p style={{ display: 'flex', justifyContent:'center', marginTop: "16px", fontSize: "12px", color: 'var(--bg-dark)', fontFamily: "'Open Sans','sans-serif'" }}> Scroll/Pinch to Zoom: {zoom.toFixed(2)*1000}%</p>
                    </div>

                    {isExporting && (
                <>
                                <div style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                                    backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex',
                                    alignItems: 'center', justifyContent: 'center'
                                }}>

                                    <h1>EXPORTING</h1>

                                    <Spinner />
                                    <p style={{ fontSize: "12px", color: "white", marginLeft: "8px" }}>
                                        Please wait while we generate your PDF.
                                    </p>

                                </div>
                                </>
                                )}

                    {showRibbonContent && (
                        <>

                            {(deviceType === "phone") && (
                                                <div className='layout'
                                                style={{display: 'flex', flexDirection: 'column',  background: "transparent", border: '0px' }}>
                                                    <canvas
                                                    ref={canvasRef}
                                                    width={screenWidth}
                                                    height={screenWidth}

                                                    style={{ border: "0px solid #ccc", touchAction: "none", cursor: "grab", height:'100%' }}
                                                />
                                                </div>
                            )}
                            {(deviceType !== "phone") && (
                                <div className='layout'
                                style={{display: 'flex', flexDirection: 'column',  background: "transparent", border: '0px' }}>
                                    <canvas
                                    ref={canvasRef}
                                    width={screenWidth}
                                    height={screenHeight*.7}


                                    style={{ border: "0px solid #ccc", touchAction: "none", cursor: "grab", height:'100%' }}
                                />
                                </div>
                            )}
                        </>
                    )}
                    {!showRibbonContent && (

                                            <div className='layout'
                                            style={{display: 'flex', flexDirection: 'column',  background: "transparent", border: '0px' }}>
                                                <canvas
                                                ref={canvasRef}
                                                width={screenWidth}
                                                height={screenHeight*.85}


                                                style={{ border: "0px solid #ccc", touchAction: "none", cursor: "grab", height:'100%' }}
                                            />
                                            </div>
                        )
                    }


                    <div className='footer'
                    style={{
                        width: '100%',
                        flex: '1',
                        backgroundColor: 'var(--secondary-color)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '0px',
                        maxHeight: '60px',
                    }}>
                        <p style={{ fontSize: "12px", color: "white", marginLeft: "8px" }}>
                            © 2025 DeoSolar
                        </p>
                        < button
                            style={{ fontSize: "12px", color: "white", marginLeft: "8px", background: 'transparent', border:'0px'}}
                            onClick={() => setShowTC(true)}
                            >
                            T&Cs
                        </button>
                    </div>
                </div>

                {modalContent && (
                    <Modal
                        open={true}
                        title={modalContent.title}
                        content={modalContent.content}
                        imageUrl={modalContent.imageUrl}
                        onClose={closeModal}
                    />
                )}

                {showExportModal && (
                        <PdfModal
                            open={true}
                            setPDFname={setPDFName}
                            pdfName={pdfName}
                            onClose={() => {
                                exportToPDF();
                                setShowExportModal(false);
                            }}
                            setShowExportModal={setShowExportModal}
                            setTempValue={setTempValue}
                            tempValue={tempValue}
                            noOfRoofs={noOfRoofs}
                        />
                    )}

                {showCoordsModal && (
                        <PdfModal
                            open={true}
                            setPDFname={setPDFName}
                            pdfName={pdfName}
                            onClose={() => {
                                ExportCoords();
                                setShowCoordsModal(false);
                            }}
                            setShowExportModal={setShowCoordsModal}
                            setTempValue={setTempValue}
                            tempValue={tempValue}
                            noOfRoofs={noOfRoofs}
                        />
                    )}

                {isModalOpen && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                            backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex',
                            alignItems: 'center', justifyContent: 'center'
                        }}>
                            <div style={{
                            background: '#fff', padding: '20px', borderRadius: '8px', minWidth: '300px'
                            }}>
                            <h3>Set Roof Name</h3>
                            <input
                                type="text"
                                value={pdfName}
                                onChange={e => {setModalName(e.target.value); setPDFName(e.target.value)}}
                                style={{ width: '100%', marginBottom: '12px', padding: '8px' }}
                            />
                            <h3>Select Roof Type</h3>
                            <RoofTypeSelector
                            setBracketType={setBracketType}
                            bracketType={bracketType}
                            bracketTypeId={bracketTypeId}
                            setBracketTypeId={setBracketTypeId}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button onClick={confirmAdd} disabled={bracketType==='Please Select'}>Confirm</button>
                                <button onClick={()=>cancelAdd()}>Cancel</button>
                            </div>
                            </div>
                        </div>
                        )}







                </>
            )}

            {showConsent && (
                <>
                <div
                    style={{
                        display: "flex", flexDirection: "column",
                    }}>
                        <div style={{
                            width: '100%',
                            maxHeight: '60px',
                            backgroundColor: 'var(--secondary-color)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0px',
                        }}>


                        <img src={logo_H_img} alt="Logo" style={{ height: "35px", marginRight: "10px" }} onClick={() => window.open('https://www.deosolar.co.za', '_blank')}/>
                        </div>

                        <div style={{
                            width: '100%',
                            flex: '1',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '25px',
                            backgroundColor: 'var(--bg-gradient-color)',
                            alignContent: 'center',
                            flexDirection: 'column',
                        }}
                        >
                            <img   src={logo_V_img} style={{ height: "300px", padding: '16px', alignSelf:"center" }}  alt="logo"/>

                            <h1>
                                Welcome to the DeoSolar Bracket Spacer and Solar Panel Layout Tool!
                            </h1>
                        </div>
                    </div>



            <div style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                background: "#fff",
                borderTop: "2px solid #000",
                padding: "20px",
                zIndex: 9999,
                boxShadow: "0 -2px 10px rgba(0,0,0,0.3)"
            }}>
                <h2 style={{ marginBottom: 10 }}>Consent</h2>
                <p style={{ marginBottom: 10 }}>
                This site uses cookies and stores data you provide in compliance with the POPIA Act. By using this application, you agree to these terms.
                </p>
                <h2 style={{ marginBottom: 10 }}>Disclaimer</h2>
                <p style={{ marginBottom: 10 }}>
                By using this site you accept our terms and conditions. The user assumes all risk from the use of this website. Output is generated based on user-provided input.  It is the sole responsibility of the user to ensure all measurements are accurate and verified on site. DeoSolar accepts no liability for errors resulting from incorrect or incomplete input. Use of this drawing is at the client’s own risk. DeoSolar and its logo are the property of the company. All content is protected by copyright and may not be reproduced or distributed without permission.
                </p>
                <button onClick={handleAccept} style={{ padding: "10px 20px", background: "black", color: "white", border: "none" }}>
                I Understand & Accept
                </button>
            </div>
            </>
            )}

        </div>
    );
    };


export default BracketSpacer;